import "../Icon.css";
import { jsx, jsxs } from "react/jsx-runtime";
import ExclamationCircleOutlined from "@ant-design/icons/ExclamationCircleOutlined";
import HolderOutlined from "@ant-design/icons/HolderOutlined";
import MinusCircleOutlined from "@ant-design/icons/MinusCircleOutlined";
import ProjectOutlined from "@ant-design/icons/ProjectOutlined";
import { useMemo } from "react";
import { useTheme } from "./Theme/UI.js";
import "./Theme/themeUtils.js";
import "./Theme/themes.js";
import Tooltip from "./Tooltip.js";
import Active from "./Icon/Active.js";
import Queue from "./Icon/Queue.js";
import { SpinBowtie, SpinHalf, SpinShadow } from "./Icon/Spin.js";
const base = "Icon_base_fd37f";
const tiny = "Icon_tiny_fd37f";
const small = "Icon_small_fd37f";
const medium = "Icon_medium_fd37f";
const large = "Icon_large_fd37f";
const big = "Icon_big_fd37f";
const great = "Icon_great_fd37f";
const huge = "Icon_huge_fd37f";
const enormous = "Icon_enormous_fd37f";
const giant = "Icon_giant_fd37f";
const jumbo = "Icon_jumbo_fd37f";
const mega = "Icon_mega_fd37f";
const cancel = "Icon_cancel_fd37f";
const error = "Icon_error_fd37f";
const success = "Icon_success_fd37f";
const filter = "Icon_filter_fd37f";
const spin = "Icon_spin_fd37f";
const spinning = "Icon_spinning_fd37f";
const css = {
  base,
  tiny,
  small,
  medium,
  large,
  big,
  great,
  huge,
  enormous,
  giant,
  jumbo,
  mega,
  cancel,
  error,
  success,
  filter,
  spin,
  spinning
};
const ReactComponent$1f = (props) => /* @__PURE__ */ jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1024 1024",
  ...props,
  children: /* @__PURE__ */ jsx("path", {
    d: "M555 64q0-18-12.5-30.5T512 21t-30.5 12.5T469 64v427H43q-18 0-30.5 12.5T0 533q0 18 12.5 30.5T43 576h426v427q0 17 12.5 29.5T512 1045t30.5-12.5T555 1003V576h426q18 0 30.5-12.5T1024 533q0-17-12.5-29.5T981 491H555z"
  })
});
const AddIcon = ReactComponent$1f;
const ReactComponent$1e = (props) => /* @__PURE__ */ jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1024 1024",
  ...props,
  children: /* @__PURE__ */ jsx("path", {
    d: "M107 107q-27 0-45.5 18.5T43 171v128q0 26 18.5 45t45.5 19h810q27 0 45.5-19t18.5-45V171q0-27-18.5-45.5T917 107zm0 42h810q9 0 15.5 6.5T939 171v128q0 9-6.5 15t-15.5 6H107q-9 0-15.5-6T85 299V171q0-9 6.5-15.5T107 149m64 171q-18 0-30.5 12.5T128 363v537q0 27 19 45.5t45 18.5h640q26 0 45-18.5t19-45.5V363q0-18-12.5-30.5T853 320zm0 43h682v537q0 9-6 15.5t-15 6.5H192q-9 0-15-6.5t-6-15.5zm222 85q-21 0-36.5 15T341 499v68q0 21 15.5 36.5T393 619h238q21 0 36.5-15.5T683 567v-68q0-21-15.5-36T631 448zm0 43h238q4 0 6.5 2t2.5 6v68q0 4-2.5 6.5T631 576H393q-4 0-6.5-2.5T384 567v-68q0-4 2.5-6t6.5-2"
  })
});
const ArchiveIcon = ReactComponent$1e;
const ReactComponent$1d = (props) => /* @__PURE__ */ jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1024 1024",
  ...props,
  children: /* @__PURE__ */ jsx("path", {
    d: "M55 290q13-13 30.5-13t30.5 13l396 396 396-396q13-13 30.5-13t30.5 13q12 12 12 30t-12 30L542 777q-12 12-30 12t-30-12L55 350q-12-12-12-30t12-30"
  })
});
const ArrowDownIcon = ReactComponent$1d;
const ReactComponent$1c = (props) => /* @__PURE__ */ jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1024 1024",
  ...props,
  children: /* @__PURE__ */ jsx("path", {
    d: "M756 76q12 13 12 30.5T756 137L359 533l397 397q12 12 12 30t-12 30q-13 13-30.5 13T695 990L268 564q-12-13-12-30.5t12-30.5L695 76q13-12 30.5-12T756 76"
  })
});
const ArrowLeftIcon = ReactComponent$1c;
const ReactComponent$1b = (props) => /* @__PURE__ */ jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1024 1024",
  ...props,
  children: /* @__PURE__ */ jsx("path", {
    d: "M226 990q-13-12-13-30t13-30l396-397-396-396q-13-13-13-30.5T226 76q12-12 30-12t30 12l427 427q12 13 12 30.5T713 564L286 990q-12 13-30 13t-30-13"
  })
});
const ArrowRightIcon = ReactComponent$1b;
const ReactComponent$1a = (props) => /* @__PURE__ */ jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1024 1024",
  ...props,
  children: /* @__PURE__ */ jsx("path", {
    d: "M969 777q-13 12-30.5 12T908 777L512 380 116 777q-13 12-30.5 12T55 777q-12-13-12-30.5T55 716l427-426q12-13 30-13t30 13l427 426q12 13 12 30.5T969 777"
  })
});
const ArrowUpIcon = ReactComponent$1a;
const ReactComponent$19 = (props) => /* @__PURE__ */ jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1024 1024",
  ...props,
  children: /* @__PURE__ */ jsx("path", {
    d: "M783 805 212 294q-40 49-62 110t-22 129q0 80 30 150t82.5 122T363 887q69 30 149 30 79 0 149-30t122-82m29-31q39-50 61.5-111T896 533q0-79-30-149t-82.5-122T661 180q-69-31-149-31t-150 30.5T240 262zm127-241q0 89-34 166-33 78-91 136t-136 91q-78 34-166 34t-166-34q-78-33-136-91t-91-136q-34-77-34-166 0-88 34-166 33-77 91-135t136-92q78-33 166-33t166 33q78 34 136 92t91 135q34 78 34 166"
  })
});
const CancelledIcon = ReactComponent$19;
const ReactComponent$18 = (props) => /* @__PURE__ */ jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1024 1024",
  ...props,
  children: /* @__PURE__ */ jsx("path", {
    d: "M839 318q6 6 6 15t-6 15L433 753q-6 6-15 6t-15-6L190 540q-7-6-7-15t7-15q6-7 15-7t15 7l198 198 390-390q7-7 15.5-7t15.5 7"
  })
});
const CheckmarkIcon = ReactComponent$18;
const ReactComponent$17 = (props) => /* @__PURE__ */ jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1024 1024",
  ...props,
  children: /* @__PURE__ */ jsx("path", {
    d: "M171 171q0-9 6-15.5t15-6.5h640q6 0 11.5 4t8.5 10q2 5 1 11.5t-6 11.5L649 384l198 198q5 5 6 11.5t-1 11.5q-3 6-8.5 10t-11.5 4H213v277q0 9-6 15t-15 6-15-6-6-15zm42 405h567L604 399q-7-6-7-15t7-15l176-177H213z"
  })
});
const CheckpointIcon = ReactComponent$17;
const ReactComponent$16 = (props) => /* @__PURE__ */ jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1024 1024",
  ...props,
  children: /* @__PURE__ */ jsx("path", {
    d: "M438 107h-75q-21 0-37.5 12T302 149h-67q-27 0-45.5 19T171 213v683q0 27 18.5 45.5T235 960h554q27 0 45.5-18.5T853 896V576h107q9 0 15-6t6-15-6-15.5-15-6.5H853V213q0-26-18.5-45T789 149h-67q-7-18-23.5-30T661 107h-75q-11-19-30.5-31T512 64t-43.5 12-30.5 31m373 426H542l134-134q7-6 7-15t-7-15q-6-6-15-6t-15 6L460 555l186 185q6 7 15 7t15-7q7-6 7-15t-7-15L542 576h269v320q0 9-6.5 15t-15.5 6H235q-9 0-15.5-6t-6.5-15V213q0-9 6.5-15t15.5-6h64v21q0 27 18.5 45.5T363 277h298q27 0 45.5-18.5T725 213v-21h64q9 0 15.5 6t6.5 15zM683 171v42q0 9-6.5 15.5T661 235H363q-9 0-15.5-6.5T341 213v-42q0-9 6.5-15.5T363 149h106q0-17 12.5-29.5T512 107t30.5 12.5T555 149h106q9 0 15.5 6.5T683 171"
  })
});
const ClipboardIcon = ReactComponent$16;
const ReactComponent$15 = (props) => /* @__PURE__ */ jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1024 1024",
  ...props,
  children: /* @__PURE__ */ jsx("path", {
    d: "M875 231q12-13 12-30.5T875 170q-13-12-30.5-12T815 170L512 473 209 170q-12-12-29.5-12T149 170q-12 13-12 30.5t12 30.5l303 302-301 301q-13 13-13 30.5t13 29.5q12 13 30 13t30-13l301-300 301 300q12 13 30 13t30-13q13-12 13-29.5T873 834L572 533z"
  })
});
const CloseIcon = ReactComponent$15;
const ReactComponent$14 = (props) => /* @__PURE__ */ jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1024 1024",
  ...props,
  children: /* @__PURE__ */ jsx("path", {
    d: "m387 376-34-9q-8-2-16-3t-17-1q-53 0-90.5 37.5T192 491q0 10 1.5 20t4.5 19l13 39-40 14q-37 13-61.5 46T85 704q0 51 34.5 87.5T204 832h551l9-1q74-6 124.5-61T939 640q0-66-40-117t-100-68l-30-8-1-31q-4-76-59.5-128.5T576 235q-57 0-103.5 30.5T403 344zm381 498v1l-567-1q-67-5-112.5-54T43 704q0-56 32-100t82-61q-4-13-6-26t-2-26q0-71 50-121t121-50q11 0 22.5 1.5T364 326q28-60 85-97t127-37q47 0 89 17 41 18 72.5 48t51.5 70q19 41 21 87 74 21 122.5 83T981 640q0 46-16 87-17 40-45.5 71.5T852 850t-84 24"
  })
});
const CloudIcon = ReactComponent$14;
const ReactComponent$13 = (props) => /* @__PURE__ */ jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1024 1024",
  ...props,
  children: /* @__PURE__ */ jsx("path", {
    d: "M320 21q9 0 15 6.5t6 15.5v64h86V43q0-9 6-15.5t15-6.5 15 6.5 6 15.5v64h86V43q0-9 6-15.5t15-6.5 15 6.5 6 15.5v64h86V43q0-9 6-15.5t15-6.5 15 6.5 6 15.5v64h162q22 0 37 15t15 36v162h64q8 0 14.5 6t6.5 15-6.5 15.5-14.5 6.5h-64v85h64q8 0 14.5 6t6.5 15-6.5 15.5-14.5 6.5h-64v85h64q8 0 14.5 6t6.5 15-6.5 15.5-14.5 6.5h-64v85h64q8 0 14.5 6t6.5 15-6.5 15.5-14.5 6.5h-64v162q0 21-15 36t-37 15H725v64q0 9-6 15t-15 6-15-6-6-15v-64h-86v64q0 9-6 15t-15 6-15-6-6-15v-64h-86v64q0 9-6 15t-15 6-15-6-6-15v-64h-86v64q0 9-6 15t-15 6-15-6-6-15v-64H137q-22 0-37-15t-15-36V747H21q-9 0-15-6.5T0 725t6-15 15-6h64v-85H21q-9 0-15-6.5T0 597t6-15 15-6h64v-85H21q-9 0-15-6.5T0 469t6-15 15-6h64v-85H21q-9 0-15-6.5T0 341t6-15 15-6h64V158q0-21 15-36t37-15h162V43q0-9 6-15.5t15-6.5m0 128H137q-4 0-6.5 2.5T128 158v751q0 3 2.5 5.5t6.5 2.5h750q4 0 6.5-2.5t2.5-5.5V158q0-4-2.5-6.5T887 149zm439 128q4 0 6.5 2.5t2.5 6.5v495q0 3-2.5 5.5T759 789H265q-4 0-6.5-2.5T256 781V286q0-4 2.5-6.5t6.5-2.5zm-494-42q-22 0-37 15t-15 36v495q0 21 15 36t37 15h494q22 0 37-15t15-36V286q0-21-15-36t-37-15zm119 128q0 17-12.5 29.5T341 405h-42v-85h42q18 0 30.5 12.5T384 363m128 42-43-85-42 85zm85-85h-42v85h42z"
  })
});
const ClusterIcon = ReactComponent$13;
const ReactComponent$12 = (props) => /* @__PURE__ */ jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1024 1024",
  ...props,
  children: /* @__PURE__ */ jsx("path", {
    d: "M770 326q7 6 7 15t-7 15L636 491h367q9 0 15 6t6 15-6 15-15 6H636l134 135q7 6 7 15t-7 15q-6 6-15 6t-15-6L554 512l186-186q6-6 15-6t15 6m-516 0q-7 6-7 15t7 15l134 135H21q-9 0-15 6t-6 15 6 15 15 6h367L254 668q-7 6-7 15t7 15q6 6 15 6t15-6l186-186-186-186q-6-6-15-6t-15 6"
  })
});
const CollapseIcon = ReactComponent$12;
const ReactComponent$11 = (props) => /* @__PURE__ */ jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: /* @__PURE__ */ jsx("path", {
    fill: "currentcolor",
    fillRule: "evenodd",
    d: "M9 5H5v14h4zM5 20h14a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1m10-1h4V5h-4zm-1 0V5h-4v14z",
    clipRule: "evenodd"
  })
});
const ColumnsIcon = ReactComponent$11;
const ReactComponent$10 = (props) => /* @__PURE__ */ jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1024 1024",
  ...props,
  children: /* @__PURE__ */ jsx("path", {
    d: "M51 107q-3 0-5.5 2.5T43 115v77h938v-77q0-3-2.5-5.5T973 107zm-8 128v716q0 4 2.5 6.5T51 960h922q3 0 5.5-2.5t2.5-6.5V235zM0 115q0-21 15-36t36-15h922q21 0 36 15t15 36v836q0 22-15 37t-36 15H51q-21 0-36-15T0 951zm164 211 256 256q7 6 7 15t-7 15L164 868q-6 7-15 7t-15-7q-6-6-6-15t6-15l241-241-241-241q-6-6-6-15t6-15 15-6 15 6m348 527q0 9 6 15.5t15 6.5h342q9 0 15-6.5t6-15.5-6-15-15-6H533q-9 0-15 6t-6 15"
  })
});
const CommandIcon = ReactComponent$10;
const ReactComponent$$ = (props) => /* @__PURE__ */ jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1331 1024",
  ...props,
  children: /* @__PURE__ */ jsx("path", {
    d: "M146 241q32-1 56.5 20.5T228 315q2 32-19.5 56.5T155 398t-56.5-20T72 324q-1-33 20.5-57t53.5-26m897-67q30-2 52 18t24 50-18 52.5-50 24.5q-9 0-17.5-1t-15.5-5l-1 1q-30 7-53.5 23.5T922 379q1 3 1.5 6.5t.5 6.5q3 38-23 66.5T836 490q-38 2-66.5-23.5T739 402q-3-38 23-66.5t64-31.5q15-1 28.5 2.5T879 317q29-9 53-25.5t43-39.5v-2q-3-30 17-52t51-24m-441 24q-31 2-50.5 24.5T533 275q2 30 24.5 50t52.5 18 50-24 18-53q18-27 40-42t47-20q12 8 26 11.5t29 2.5q39-3 65-32t23-67q-2-39-31-65t-68-24q-39 3-65 32t-23 67q0 4 .5 7t1.5 6q-17 24-39 38.5T636 203h-1q-8-3-16.5-4.5T602 198m458 462q7 0 13.5.5t13.5 3.5v-1q40-14 67-36.5t42-52.5v-1q1-23 16.5-39.5T1251 516q24-1 42 15t20 40q1 24-15 42t-40 20q-4 0-7-.5t-7-.5q-34 14-61.5 36.5T1135 722v6q2 30-18 52t-49 24q-30 2-52.5-18T991 736q-1-30 19-52t50-24m-554-29q35-2 61 21t28 58q1 35-22 61t-58 28-61-21.5-28-57.5q0-9 1-17t4-16q-11-29-33-50t-50-36q-7 2-14 3.5t-14 1.5q-39 3-68-23t-31-65q-3-39 23-68t65-31q39-3 68 23t31 65q1 11-1 21t-6 20q13 28 34 49.5t49 35.5l2 1q5-1 9.5-2t10.5-1m435 238q-19-23-33.5-47.5T886 771q14-15 22-34.5t7-42.5q0-8-1.5-15t-4.5-14q28-31 60-56.5t70-43.5v-1q8 3 15.5 4t15.5 1q31-2 52-25.5t20-54.5q-2-32-25.5-53t-54.5-19-52 25.5-20 54.5q0 2 .5 4t.5 4q-26 37-57 63.5T868 615q-13-8-28-12t-30-3q-11 0-21.5 3t-19.5 8q-29-20-53.5-45T673 511q3-10 5-21t2-22q-3-42-34-70t-73-25q-42 2-70 33.5T477 480q3 41 34.5 69t72.5 26q10-1 19-3t17-6l1 1q31 17 56.5 40.5T724 657q-5 12-7 24t-1 24q2 42 33 69.5t72 25.5q3 0 5-.5t5-1.5q17 23 29.5 48.5T880 900q-9 11-13.5 25t-3.5 29q2 33 27.5 56t58.5 21q34-2 56.5-27.5T1026 945t-26.5-55-58.5-21M285 657q-22 1-36 17t-13 37q2 22 17.5 36t37.5 13q21-2 35.5-17.5T339 705q-1-21-17-35.5T285 657M89 479q32-2 56.5 19.5T172 553q1 32-20.5 56T98 635t-56.5-19.5T15 561q-2-32 20-56t54-26m1119-158q21-2 37 12.5t17 35.5q2 22-12.5 38t-36.5 17q-21 1-37-13.5t-17-35.5 13-37 36-17M541 42q21-2 37 12.5T595 90q2 22-12.5 38T547 145q-22 1-38-13.5T492 96t13-37 36-17m-179 76q39-2 68 24t31 65q3 39-23.5 68T372 307q-39 2-68-24t-31-65q-3-40 23-69t66-31"
  })
});
const DaiLogoIcon = ReactComponent$$;
const ReactComponent$_ = (props) => /* @__PURE__ */ jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1138 1024",
  ...props,
  children: /* @__PURE__ */ jsx("path", {
    d: "M931 952q35-34 62-76 28-41 47.5-86.5T1070 693q11-50 11-103 0-106-40-199-41-93-110.5-162.5T768 118q-93-40-199-40t-199 40q-94 41-163.5 110.5T97 391 57 590q0 53 10 103 11 51 30.5 96.5T144 876q28 42 63 76l-40 40q-39-38-70-84-31-45-52.5-96T12 705Q0 649 0 590q0-118 45-221 44-104 121.5-181T347 66q104-45 222-45t221 45q104 45 181 122t122 181q45 103 45 221 0 59-12 115-11 56-33 107t-52 96q-31 46-70 84zM789 331l-20 88q-8 34-20 84t-26 100q-7 25-14 48.5T695 696q-7 20-13.5 37T668 761q-12 21-29 36.5T600 819t-44 1-43-17q-22-13-37-29.5T455 735t-1-44 17-44q7-11 18.5-25.5T515 592q14-16 31-33.5t36-35.5q36-36 74-71t66-61zM557 630q-14 16-23.5 27.5T520 676q-9 15-10.5 26t.5 18 9 15.5 22 17.5q16 9 26.5 11t18.5 0q7-2 15.5-9t17.5-22q4-8 9.5-21.5T641 678q6-20 13-43t14-47l12-46 12-45q-18 16-35.5 33T621 564l-34.5 34.5z"
  })
});
const DashboardIcon = ReactComponent$_;
const ReactComponent$Z = (props) => /* @__PURE__ */ jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1024 1024",
  ...props,
  children: /* @__PURE__ */ jsx("path", {
    d: "M427 218q0-43-22-66.5T363 128q-9 0-15.5-6t-6.5-15 6.5-15.5T363 85q40 0 69.5 33t35.5 81q11-4 22-5.5t22-1.5 22 1.5 22 5.5q6-48 35.5-81T661 85q9 0 15.5 6.5T683 107t-6.5 15-15.5 6q-20 0-42 23.5T597 218v1q29 20 46.5 52t17.5 70v11l-1 11h-43q1-6 1.5-11t.5-11q0-44-31.5-75T512 235t-75.5 31-31.5 75q0 6 .5 11t1.5 11h-43q-1-6-1-11v-11q0-38 17.5-70t46.5-52zm489 428q-14-14-46-13t-62 31q-7 6-15.5 6t-15.5-6q-6-6-6-15t6-15q38-38 88-43.5t81 25.5q7 6 7 15t-7 15q-6 6-15 6t-15-6m-700 18q-30-30-62-31t-46 13q-6 6-15 6t-15-6q-7-6-7-15t7-15q31-31 81-25.5t88 43.5q6 6 6 15t-6 15q-7 6-15.5 6t-15.5-6m650 175q-7-19-36.5-31.5T760 810q-9 3-17-1t-11-12 1-16 12-12q50-18 98-2t63 57q3 9-.5 17T893 852q-8 3-16-1t-11-12m-602-29q-40-15-69.5-2.5T158 839q-3 8-11 12t-16 1q-9-3-12.5-11t-.5-17q15-41 63-57t98 2q8 4 12 12t1 16-11 12-17 1m618-349q-18-10-48.5-.5T782 507q-5 7-13.5 9.5T752 515q-7-5-9.5-13.5T745 485q26-46 73-64.5t85 3.5q8 5 10 13.5t-2 15.5q-5 8-13.5 10.5T882 461m-640 46q-21-37-51.5-46.5t-48.5.5q-7 5-15.5 2.5T113 453q-4-7-2-15.5t10-13.5q38-22 85-3.5t73 64.5q5 8 2.5 16.5T272 515q-8 4-16.5 1.5T242 507m249 432V341h42v598zm21-22q-52 0-98-21-47-21-82-58.5T277 749q-21-51-21-109t21-109q20-51 55-88.5t82-58.5q46-21 98-21t98 21q47 21 82 58.5t55 88.5q21 51 21 109t-21 109q-20 51-55 88.5T610 896q-46 21-98 21m0 43q62 0 116-25 55-25 95.5-68.5T787 765q24-59 24-125t-24-125q-23-58-63.5-101.5T628 345q-54-25-116-25t-116 25q-55 25-95.5 68.5T237 515q-24 59-24 125t24 125q23 58 63.5 101.5T396 935q54 25 116 25"
  })
});
const DebugIcon = ReactComponent$Z;
const ReactComponent$Y = (props) => /* @__PURE__ */ jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1024 1024",
  ...props,
  children: /* @__PURE__ */ jsx("path", {
    d: "M887 235q4 0 6.5 2.5t2.5 5.5v324q0 4-2.5 6.5T887 576H137q-4 0-6.5-2.5T128 567V243q0-3 2.5-5.5t6.5-2.5zm-750-43q-22 0-37 15t-15 36v324q0 22 15 37t37 15h750q22 0 37-15t15-37V243q0-21-15-36t-37-15zm38 95h83q28 0 49.5 7.5T345 318q16 15 23.5 37t7.5 50-8 50-24 38q-16 15-38.5 23t-50.5 8h-80zm43 199h36q39 0 58-20.5t19-60.5-19-60-58-20h-36zm303 1q10 0 19-2.5t16-7.5q8-5 14.5-12.5T581 448q5-10 7.5-20.5T591 405q0-11-2-21t-7-20q-4-9-10-16.5T558 335t-17-8-20-3q-9 0-18 2.5t-17 7.5q-7 5-13.5 12T461 363q-4 9-6.5 19.5T452 405t2.5 22 6.5 19 10 16.5 14 13.5q8 5 17 8t19 3m0 42q-15 0-29.5-4T464 514q-13-8-23-19t-18-25-12-30.5-4-34.5q0-16 3.5-31.5T422 344q7-14 17-25.5t23-19.5q13-9 28-13t31-4 30.5 3.5T579 297t23 19 18 25 12 30 4 34q0 17-3.5 32.5T621 467q-7 14-17 25.5T581 512q-14 9-28.5 13t-31.5 4m261-1q-17 0-32-4t-27-11q-13-7-23.5-17.5T682 471q-8-14-11.5-30t-3.5-34 3.5-33.5T681 344q8-14 18-25t24-20q13-8 28.5-12t32.5-4q9 0 18 1.5t18 3.5q9 3 17 6.5t15 7.5l-7 41q-16-9-31-13t-29-4q-11 0-20 2.5t-18 6.5q-8 5-14.5 12T721 363q-4 9-6.5 19.5T712 406q0 18 5 32.5t15 25.5q10 10 23.5 15.5T786 485q7 0 15-1t16-4q9-2 16.5-5.5T849 467l4 41q-7 5-15.5 8.5T820 523q-9 2-18.5 3.5T782 528M299 683q0-9 6-15.5t15-6.5h171q9 0 15 6.5t6 15.5-6 15-15 6H320q-9 0-15-6t-6-15m0 128q0-9 6-15.5t15-6.5h171q9 0 15 6.5t6 15.5-6 15-15 6H320q-9 0-15-6t-6-15m503-662H222q-4 0-6.5 2.5T213 158v34h-42v-34q0-21 15-36t36-15h580q21 0 36 15t15 36v34h-42v-34q0-4-2.5-6.5T802 149M171 619h42v290q0 3 2.5 5.5t6.5 2.5h397v43H222q-21 0-36-15t-15-36zm682 106V619h-42v106zm-234-21h213q6 0 11.5 3.5t8.5 9.5q2 6 1 12.5t-6 10.5L634 954q-5 4-11.5 5.5T611 958q-6-2-10-7.5t-4-11.5V725q0-9 6.5-15t15.5-6m21 43v140l140-140z"
  })
});
const DocsIcon = ReactComponent$Y;
const ReactComponent$X = (props) => /* @__PURE__ */ jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1024 1024",
  ...props,
  children: /* @__PURE__ */ jsx("path", {
    d: "M222 149h580q4 0 6.5 2.5t2.5 6.5v567h42V158q0-21-15-36t-36-15H222q-21 0-36 15t-15 36v751q0 21 15 36t36 15h397v-43H222q-4 0-6.5-2.5T213 909V158q0-4 2.5-6.5t6.5-2.5m397 555h213q6 0 11.5 3.5t8.5 9.5q2 6 1 12.5t-6 10.5L634 954q-5 4-11.5 5.5T611 958q-6-2-10-7.5t-4-11.5V725q0-9 6.5-15t15.5-6m21 43v140l140-140zM299 256q0-9 6-15t15-6h384q9 0 15 6t6 15-6 15-15 6H320q-9 0-15-6t-6-15m0 128q0-9 6-15t15-6h384q9 0 15 6t6 15-6 15-15 6H320q-9 0-15-6t-6-15m0 128q0-9 6-15t15-6h384q9 0 15 6t6 15-6 15-15 6H320q-9 0-15-6t-6-15m0 128q0-9 6-15t15-6h384q9 0 15 6t6 15-6 15-15 6H320q-9 0-15-6t-6-15m0 128q0-9 6-15t15-6h213q9 0 15.5 6t6.5 15-6.5 15-15.5 6H320q-9 0-15-6t-6-15"
  })
});
const DocumentIcon = ReactComponent$X;
const ReactComponent$W = (props) => /* @__PURE__ */ jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1024 1024",
  ...props,
  children: /* @__PURE__ */ jsx("path", {
    d: "M512 196q9 0 15 6.5t6 15.5v498l177-176q6-7 15-7t15 7q7 6 7 15t-7 15L527 783q-6 6-15 6t-15-6L284 570q-7-6-7-15t7-15q6-7 15-7t15 7l177 176V218q0-9 6-15.5t15-6.5M192 832q-9 0-15 6t-6 15 6 15.5 15 6.5h640q9 0 15-6.5t6-15.5-6-15-15-6z"
  })
});
const DownloadIcon = ReactComponent$W;
const ReactComponent$V = (props) => /* @__PURE__ */ jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1024 1024",
  ...props,
  children: /* @__PURE__ */ jsx("path", {
    d: "M512 917q-80 0-149-30-70-30-122.5-82T158 683t-30-150q0-79 30-149t82.5-122T363 180q69-31 149-31t149 31q70 30 122.5 82T866 384t30 149q0 80-30 150t-82.5 122T661 887q-69 30-149 30m0 43q88 0 166-34 78-33 136-91t91-136q34-77 34-166 0-88-34-166-33-77-91-135t-136-92q-78-33-166-33t-166 33q-78 34-136 92t-91 135q-34 78-34 166 0 89 34 166 33 78 91 136t136 91q78 34 166 34M331 352q-7 6-7 15t7 15l151 151-151 151q-6 6-6 15t6 15q7 6 15.5 6t15.5-6l150-150 150 150q7 6 15.5 6t15.5-6q6-6 6-15t-6-15L542 533l151-151q7-6 7-15t-7-15q-6-6-14.5-6t-15.5 6L512 503 361 352q-7-6-15.5-6t-14.5 6"
  })
});
const ErrorIcon = ReactComponent$V;
const ReactComponent$U = (props) => /* @__PURE__ */ jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1024 1024",
  ...props,
  children: /* @__PURE__ */ jsx("path", {
    d: "M216 326q6 6 6 15t-6 15L81 491h367q9 0 15 6t6 15-6 15-15 6H81l135 135q6 6 6 15t-6 15q-7 6-15.5 6t-15.5-6L0 512l185-186q7-6 15.5-6t15.5 6m592 0q-6 6-6 15t6 15l135 135H576q-9 0-15 6t-6 15 6 15 15 6h367L808 668q-6 6-6 15t6 15q7 6 15.5 6t15.5-6l185-186-185-186q-7-6-15.5-6t-15.5 6"
  })
});
const ExpandIcon = ReactComponent$U;
const ReactComponent$T = (props) => /* @__PURE__ */ jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1024 1024",
  ...props,
  children: /* @__PURE__ */ jsx("path", {
    d: "M939 917q0-8-3-15.5t-9-12.5L760 686q-6 8-15 13t-20 5H299q-11 0-20-5t-15-13L97 888q-6 6-9 13.5T85 917q0 18 12.5 30.5T128 960h768q18 0 30.5-12.5T939 917M384 107v365L63 862l-5 7q-7 10-11 22.5T43 917q0 36 25 61t60 25h768q35 0 60-25t25-61q0-13-4-25.5T966 869l-5-7-321-390V107h43q9 0 15-6.5t6-15.5-6-15-15-6H341q-9 0-15 6t-6 15 6 15.5 15 6.5zm619 738h-2 1v1l1 1q6 9 10.5 19t6.5 21q2 8 3 15.5t1 14.5q0 53-37.5 90.5T896 1045H128q-53 0-90.5-37.5T0 917q0-7 1-14.5T4 887q2-11 6.5-21T21 847l1-1v-1h1-2l320-388V149q-26 0-45-18.5T277 85q0-26 19-45t45-19h342q26 0 45 19t19 45q0 27-19 45.5T683 149v308zM341 341q0-9 6.5-15t15.5-6h85q9 0 15 6t6 15-6 15.5-15 6.5h-85q-9 0-15.5-6.5T341 341m0-128q0-9 6.5-15t15.5-6h85q9 0 15 6t6 15-6 15.5-15 6.5h-85q-9 0-15.5-6.5T341 213"
  })
});
const ExperimentIcon = ReactComponent$T;
const ReactComponent$S = (props) => /* @__PURE__ */ jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1024 1024",
  ...props,
  children: /* @__PURE__ */ jsx("path", {
    d: "M652 300q-31-10-66-16.5t-74-6.5q-85 0-149 26-64 27-110 64.5T177 448t-47 76l-5 9 5 10q20 40 59.5 92T293 728l28-33q-56-34-92-79t-56-83q17-31 45-68 27-37 68.5-69.5T384 342q55-22 128-22 31 0 58.5 4t51.5 12zm-66 79q-17-8-35.5-12t-38.5-4q-71 0-121 50t-50 120q0 28 8.5 53.5T373 633zM402 664l220-261q28 23 44.5 57t16.5 73q0 71-50 121t-121 50q-31 0-59-10.5T402 664m-43 51q33 15 71 23.5t82 8.5q73 0 128-22 56-22 97.5-54t68.5-69q28-37 45-69-23-43-68-96t-118-86l28-33q81 39 129.5 100T894 524l5 9-5 10q-17 33-47 76-30 42-76 80t-110 64-149 26q-53 0-98.5-11T331 749zm430-478q7 5 7.5 14t-4.5 16L298 855q-6 7-14.5 7.5T268 858q-7-6-8-15t5-16l494-588q6-7 14.5-7.5T789 237"
  })
});
const EyeCloseIcon = ReactComponent$S;
const ReactComponent$R = (props) => /* @__PURE__ */ jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1024 1024",
  ...props,
  children: /* @__PURE__ */ jsx("path", {
    d: "M512 747q-73 0-128-22-56-22-97.5-54T218 602q-28-37-45-69 17-31 45-68 27-37 68.5-69.5T384 342q55-22 128-22t128 22q56 21 97.5 53.5T806 465q28 37 45 68-17 32-45 69-27 37-68.5 69T640 725q-55 22-128 22m0-470q-85 0-149 26-64 27-110 64.5T177 448t-47 76l-5 9 5 10q17 33 47 76 30 42 76 80t110 64 149 26 149-26 110-64 76-80q30-43 47-76l5-10-5-9q-17-33-47-76t-76-80.5T661 303q-64-26-149-26m0 427q71 0 121-50t50-121q0-70-50-120t-121-50-121 50-50 120q0 71 50 121t121 50"
  })
});
const EyeOpenIcon = ReactComponent$R;
const ReactComponent$Q = (props) => /* @__PURE__ */ jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: /* @__PURE__ */ jsx("path", {
    fill: "currentcolor",
    fillRule: "evenodd",
    d: "M5 7.5a.5.5 0 0 0 0 1h14a.5.5 0 0 0 0-1zM7.5 12a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 0 1H8a.5.5 0 0 1-.5-.5m3 4a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5",
    clipRule: "evenodd"
  })
});
const FilterIcon = ReactComponent$Q;
const ReactComponent$P = (props) => /* @__PURE__ */ jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1024 1024",
  ...props,
  children: /* @__PURE__ */ jsx("path", {
    d: "M213 277q-35 0-60-25t-25-60 25-60 60-25q36 0 61 25t25 60-25 60-61 25m0 43q53 0 90.5-37.5T341 192t-37.5-90.5T213 64t-90.5 37.5T85 192t37.5 90.5T213 320m598-43q-36 0-61-25t-25-60 25-60 61-25q35 0 60 25t25 60-25 60-60 25m0 43q53 0 90.5-37.5T939 192t-37.5-90.5T811 64t-90.5 37.5T683 192t37.5 90.5T811 320M512 960q-35 0-60-25t-25-60q0-36 25-61t60-25 60 25 25 61q0 35-25 60t-60 25m0 43q53 0 90.5-37.5T640 875t-37.5-90.5T512 747t-90.5 37.5T384 875t37.5 90.5T512 1003M192 277h43v172q0 11 5 22t15 21q10 9 21.5 14.5T298 512q24-1 72.5-.5t89.5.5h265q11 0 22.5-5.5T769 492q10-10 15-21t5-22V277h43v172q0 21-9.5 40T799 522t-33.5 23.5T725 555H533v234h-42V555h-15l-17-1h-89.5l-70.5 1q-21 0-40.5-9.5T225 522t-23.5-33-9.5-40z"
  })
});
const ForkIcon = ReactComponent$P;
const ReactComponent$O = (props) => /* @__PURE__ */ jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16",
  ...props,
  children: /* @__PURE__ */ jsx("path", {
    fill: "currentcolor",
    d: "M2 10h3a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1m9-9h3a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-3a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1m0 9a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1zm0-10a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h3a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zM2 9a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h3a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2zm7 2a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2h-3a2 2 0 0 1-2-2zM0 2a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm5.354.854a.5.5 0 1 0-.708-.708L3 3.793l-.646-.647a.5.5 0 1 0-.708.708l1 1a.5.5 0 0 0 .708 0z"
  })
});
const FourSquaresIcon = ReactComponent$O;
const ReactComponent$N = (props) => /* @__PURE__ */ jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1024 1024",
  ...props,
  children: /* @__PURE__ */ jsx("path", {
    d: "M149 149q-9 0-15 6.5t-6 15.5v256q0 9 6 15t15 6 15.5-6 6.5-15V192h234q9 0 15.5-6t6.5-15-6.5-15.5T405 149zm470 0q-9 0-15.5 6.5T597 171t6.5 15 15.5 6h234v235q0 9 6.5 15t15.5 6 15-6 6-15V171q0-9-6-15.5t-15-6.5zM149 619q9 0 15.5 6t6.5 15v235h234q9 0 15.5 6t6.5 15-6.5 15-15.5 6H149q-9 0-15-6t-6-15V640q0-9 6-15t15-6m747 21q0-9-6-15t-15-6-15.5 6-6.5 15v235H619q-9 0-15.5 6t-6.5 15 6.5 15 15.5 6h256q9 0 15-6t6-15z"
  })
});
const FullscreenIcon = ReactComponent$N;
const ReactComponent$M = (props) => /* @__PURE__ */ jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1024 1024",
  ...props,
  children: /* @__PURE__ */ jsx("path", {
    d: "M299 235v85h-86v-85zm-128-43v171h170V192zm384 43v85h-86v-85zm-128-43v171h170V192zm384 43v85h-86v-85zm-128-43v171h170V192zM299 491v85h-86v-85zm-128-43v171h170V448zm384 43v85h-86v-85zm-128-43v171h170V448zm384 43v85h-86v-85zm-128-43v171h170V448zM299 747v85h-86v-85zm-128-43v171h170V704zm384 43v85h-86v-85zm-128-43v171h170V704zm384 43v85h-86v-85zm-128-43v171h170V704z"
  })
});
const GridIcon = ReactComponent$M;
const ReactComponent$L = (props) => /* @__PURE__ */ jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1293 1024",
  ...props,
  children: /* @__PURE__ */ jsx("path", {
    d: "M394 21q81 0 145.5 41T632 166h29q29-63 93-104t145-41q52 0 98 19t80 51.5 54 76.5q21 44 21 94-1 55-25 102.5t-64 80.5q42 21 77 52t60 69.5 39 83.5q14 44 14 93v96h-101v-96q0-50-20-93-20-44-54.5-77T997 521q-46-18-98-18h-21q-11 25-28 46.5T811 589q42 21 77 52t60 69.5 39 83.5q13 45 13 93v145H899V887q0-49-19-93-20-44-54.5-76.5T745 666t-98-19q-53 0-99 19t-80 51.5-54 76.5-20 93v145H293V887q0-48 14-93t38.5-83.5T405 641t77-52q-21-18-38-39.5T415 503h-21q-52 0-98 18-46 19-80 52t-55 77q-20 43-20 93v96H40v-96q0-49 14-93 14-45 39-83.5t60-69.5 78-52q-41-33-65-80.5T141 262q1-50 21-94t54.5-76.5T297 40q45-19 97-19m139 170q-19-31-55.5-52T394 118q-61 0-106 42t-45 102 45 102 106 42q0-70 38.5-127.5T533 191m366 215q62 0 106.5-42t45.5-102q-1-60-45.5-102T899 118q-46 0-82.5 21T761 191q61 30 99.5 87.5T899 406M647 551q63 0 107-42.5T798 406t-44-102-107-42-107.5 42T495 406t44.5 102.5T647 551"
  })
});
const GroupIcon = ReactComponent$L;
const ReactComponent$K = (props) => /* @__PURE__ */ jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1024 1024",
  ...props,
  children: /* @__PURE__ */ jsx("path", {
    d: "m574 63 1 43q2 46 10.5 80t29.5 70q4 8 9 14.5t9 14.5l2 2 2 2q5 9 11 18t12 20q7 15 14 32.5t14 40.5q13-24 30.5-43.5T760 320l41-31-8 51q-2 14 .5 29.5T802 403q6 16 14.5 33.5T835 474q0 1 1 2.5t1 2.5q21 41 40 90.5T896 676t-25 116q-26 58-75 105t-120 76q-72 30-164 30t-163-29q-72-28-121-73.5T154 798q-26-57-26-115 0-55 9-102 9-46 23.5-86.5T194 417t39-74l19-35 18 36q12 24 25 43.5t27 35.5q5-53 22.5-105.5T394 223q29-37 50-56t50-41q10-7 21.5-16T541 90zm-56 99q-28 21-46 37.5T428 249q-34 44-50 104t-16 118v44l-35-27q-21-17-40-39.5T251 398q-33 63-56.5 129T171 683q0 48 21 97 22 49 65 89t107 66q64 25 148 25t148-26q64-27 107-68t64-92q22-50 22-98 0-49-16.5-92.5T799 498q-1-1-1.5-2.5T796 492l-18-38-16-37q-3-8-5.5-17t-3.5-17q-17 18-29.5 39.5T701 474l-27 74-14-78q-9-47-18.5-75.5T622 347q-5-9-10-17t-11-17q0-1-1-2l-2-2q-5-7-10-15t-10-17q-19-32-29-63t-13-66q-5 4-9.5 7.5T518 162m-16 249 27 37q32 44 54 79t32 73q3 11 4 24t0 26q0 12-1.5 23.5T615 697q9-11 15.5-20t9.5-15l23-44 17 47-21 7q16-5 18.5-6l2.5-1v1.5l1 1.5q0 2 1 4t2 5q1 6 3.5 14t4.5 18q4 20 8 46t4 56q0 32-14.5 65.5T651 938q-25 28-60.5 46.5T512 1003t-78.5-18.5T373 938q-24-28-38.5-61.5T320 811q0-60 21-108.5t62-98.5q40-47 59-76.5t29-71.5zm149 309q-3 3-5.5 6t-5.5 6q-11 13-23 25t-21 19l-50 44 15-65v-1q1 0 1-1v-2q1-2 1.5-5t1.5-7q1-8 3-19t4-23 3-24 1-24q1-12 .5-21.5T574 611q-7-25-20.5-49T519 508q-12 32-32.5 59.5T436 632q-38 45-55.5 86.5T363 811q0 23 11 49.5t31 48.5q20 23 47.5 37t59.5 14 59.5-14 47.5-37q20-22 31-48.5t11-49.5q0-26-3-49t-7-42"
  })
});
const HeatIcon = ReactComponent$K;
const ReactComponent$J = (props) => /* @__PURE__ */ jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsx("path", {
      fill: "currentcolor",
      fillRule: "evenodd",
      d: "M4 5a1 1 0 0 1 .079-.39A1 1 0 0 1 4.994 4H19a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H4.994A1 1 0 0 1 4 19zm1 2.692h4V5H5zm4 7.385H5v-2.462h4zm5 0h-4v-2.462h4zm5 0h-4v-2.462h4zm0-6.154v2.462h-4V8.923zm-5 0v2.462h-4V8.923zm-5 0v2.462H5V8.923zm10 7.385h-4V19h4zM14 19v-2.692h-4V19zm-5 0v-2.692H5V19zM19 7.692V5h-4v2.692zm-5 0V5h-4v2.692z",
      clipRule: "evenodd"
    }),
    /* @__PURE__ */ jsx("path", {
      fill: "currentcolor",
      d: "M15 5h4v4h-4zM5 5h4v4H5zM15 12h4v4h-4zM10 15h4v4h-4z"
    })
  ]
});
const HeatmapIcon = ReactComponent$J;
const ReactComponent$I = (props) => /* @__PURE__ */ jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1078 1024",
  ...props,
  children: /* @__PURE__ */ jsx("path", {
    d: "M701 981h215V518L539 141 162 518v463h215V604h324zM108 572l-35 35q-8 7-19 7t-19-7q-8-8-8-19.5t8-19.5L520 83q1 0 1.5-1t1.5-1l16-16 16 16q1 0 1.5 1t1.5 1l485 485q8 8 8 19.5t-8 19.5q-8 7-19 7t-19-7l-35-35v463H647V658H431v377H108z"
  })
});
const HomeIcon = ReactComponent$I;
const ReactComponent$H = (props) => /* @__PURE__ */ jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1024 1024",
  ...props,
  children: /* @__PURE__ */ jsx("path", {
    d: "M512 917q-80 0-149-30-70-30-122.5-82T158 683t-30-150q0-79 30-149t82.5-122T363 180q69-31 149-31t149 31q70 30 122.5 82T866 384t30 149q0 80-30 150t-82.5 122T661 887q-69 30-149 30m0 43q88 0 166-34 78-33 136-91t91-136q34-77 34-166 0-88-34-166-33-77-91-135t-136-92q-78-33-166-33t-166 33q-78 34-136 92t-91 135q-34 78-34 166 0 89 34 166 33 78 91 136t136 91q78 34 166 34m-21-512v277q0 9 6 15.5t15 6.5 15-6.5 6-15.5V448q0-9-6-15t-15-6-15 6-6 15m21-85q-9 0-15-6.5t-6-15.5 6-15 15-6 15 6 6 15-6 15.5-15 6.5"
  })
});
const InfoIcon = ReactComponent$H;
const ReactComponent$G = (props) => /* @__PURE__ */ jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1024 1024",
  ...props,
  children: /* @__PURE__ */ jsx("path", {
    d: "M947 711q-34 34-80 62t-101.5 47.5T647 851t-131 11q-71 0-136-12-66-12-123-33.5T153 765t-80-67q25 67 69 123 43 56 100.5 96.5T368 980q69 23 145 23 73 0 141-22 67-21 123.5-60T878 829q43-54 69-118m0-355q-34-34-80-62t-101.5-48T647 216q-63-11-131-11-71 0-136 12-66 11-123 33t-104 52-80 67q25-67 69-123 43-56 100.5-96.5T368 87q69-23 145-23 73 0 141 22 67 21 123.5 59.5T878 238q43 54 69 118"
  })
});
const JupyterLabIcon = ReactComponent$G;
const ReactComponent$F = (props) => /* @__PURE__ */ jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1024 1024",
  ...props,
  children: /* @__PURE__ */ jsx("path", {
    d: "M502 173q5-2 10-2t10 2l470 256q5 3 8 8t3 11-3 11-8 8L522 723q-5 2-10 2t-10-2L32 467q-5-3-8-8t-3-11 3-11 8-8zM87 448l425 232 425-232-425-232zm809 277V491h43v234zm-683 43V555h43v201l256 158 256-158V555h43v213q0 6-3 10.5t-7 7.5L523 957q-5 3-11 3t-11-3L223 786q-4-3-7-7.5t-3-10.5m704-21q-9 0-15 6t-6 15 6 15 15 6 15.5-6 6.5-15-6.5-15-15.5-6m64 21q0 27-18.5 45.5T917 832q-26 0-45-18.5T853 768t19-45.5 45-18.5q27 0 45.5 18.5T981 768"
  })
});
const LearningIcon = ReactComponent$F;
const ReactComponent$E = (props) => /* @__PURE__ */ jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1024 1024",
  ...props,
  children: /* @__PURE__ */ jsx("path", {
    d: "M811 235v85H213v-85zm-640-43v171h682V192zm640 299v85H213v-85zm-640-43v171h682V448zm640 299v85H213v-85zm-640-43v171h682V704z"
  })
});
const ListIcon = ReactComponent$E;
const ReactComponent$D = (props) => /* @__PURE__ */ jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1024 1024",
  ...props,
  children: /* @__PURE__ */ jsx("path", {
    d: "M512 192q-71 0-121 50t-50 121v85h342v-85q0-71-50-121t-121-50M299 448v-85q0-45 16-83 17-39 46-68t68-46 83-17 83 17 68 46 46 68q16 38 16 83v85h77q21 0 36 15t15 36v367q0 21-15 36t-36 15H222q-21 0-36-15t-15-36V499q0-21 15-36t36-15zm426 43H222q-4 0-6.5 2.5T213 499v367q0 4 2.5 6.5t6.5 2.5h580q4 0 6.5-2.5t2.5-6.5V499q0-3-2.5-5.5T802 491z"
  })
});
const LockIcon = ReactComponent$D;
const ReactComponent$C = (props) => /* @__PURE__ */ jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1024 1024",
  ...props,
  children: /* @__PURE__ */ jsx("path", {
    d: "M802 149H222q-4 0-6.5 2.5T213 158v34h-42v-34q0-21 15-36t36-15h580q21 0 36 15t15 36v34h-42v-34q0-4-2.5-6.5T802 149M171 619h42v290q0 3 2.5 5.5t6.5 2.5h397v43H222q-21 0-36-15t-15-36zm682 106V619h-42v106zm-234-21h213q6 0 11.5 3.5t8.5 9.5q2 6 1 12.5t-6 10.5L634 954q-5 4-11.5 5.5T611 958q-6-2-10-7.5t-4-11.5V725q0-9 6.5-15t15.5-6m21 43v140l140-140zm247-512q4 0 6.5 2.5t2.5 5.5v324q0 4-2.5 6.5T887 576H137q-4 0-6.5-2.5T128 567V243q0-3 2.5-5.5t6.5-2.5zm-750-43q-22 0-37 15t-15 36v324q0 22 15 37t37 15h750q22 0 37-15t15-37V243q0-21-15-36t-37-15zm36 96h48v198h107v39H173zm302 199q11 0 20.5-2.5T513 477q9-5 16-12t12-16q5-10 7.5-20.5T551 406q0-11-2.5-21t-6.5-19q-5-10-11.5-17T515 336q-9-5-19-8t-21-3-20.5 2.5T437 335q-9 5-16 12.5T409 364t-7.5 19.5T399 406t2.5 22 7.5 19q4 9 11 16.5t15 13.5q9 5 19 7.5t21 2.5m0 43q-17 0-32.5-4T412 515q-14-8-25-19t-20-25q-8-14-12.5-30t-4.5-35q0-16 4-31.5t12-29.5 19-25 25-20q15-8 31-12.5t34-4.5q17 0 33 4t30 12q14 7 25.5 18t19.5 25q9 14 13 30t4 34q0 17-4 32.5T584 468q-7 14-18.5 25T540 513q-15 8-31 12.5t-34 4.5m288-2q-19 0-35.5-3.5T696 514q-14-7-25.5-17.5T651 472q-8-13-12-29t-4-34 4-34.5 12-30.5 19.5-25 26.5-18q15-8 33-12t38-4q11 0 21.5 1t21.5 4q10 2 20 5.5t18 7.5l-8 41q-8-4-17-7t-19-5q-9-3-19-4t-20-1q-12 0-23 2.5t-20 7.5-16.5 12-12.5 16q-6 9-8.5 19.5T683 407q0 19 5.5 33.5T705 465q11 11 26.5 16t34.5 5q10 0 21-1t23-4v-51h-47v-38h91v119q-20 9-42.5 13t-48.5 4"
  })
});
const LogsIcon = ReactComponent$C;
const ReactComponent$B = (props) => /* @__PURE__ */ jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1024 1024",
  ...props,
  children: /* @__PURE__ */ jsx("path", {
    d: "M75 280q5-3 10.5-3t10.5 3l427 256q5 3 7.5 8t2.5 11v426q0 6-2.5 11t-7.5 8q-6 3-11.5 3t-10.5-3L74 744q-4-3-7-8t-3-11V299q0-6 3-11t8-8m32 56v377l384 231V567zm842-56q5 3 8 8t3 11v426q0 6-3 11t-7 8l-427 256q-5 3-10.5 3t-11.5-3q-5-3-7.5-8t-2.5-11V555q0-6 2.5-11t7.5-8l427-256q5-3 10.5-3t10.5 3M533 567v377l384-231V336zM502 66q5-2 10-2t10 2l426 214q5 2 8.5 7t3.5 11-2.5 11-7.5 8L523 573q-5 3-11 3t-11-3L74 317q-5-3-7.5-8T64 298t3.5-11 8.5-7zM130 300l382 230 382-230-382-191z"
  })
});
const ModelIcon = ReactComponent$B;
const ReactComponent$A = (props) => /* @__PURE__ */ jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1024 1024",
  ...props,
  children: /* @__PURE__ */ jsx("path", {
    d: "M836 64q25 0 42.5 17.5T896 124v819q0 25-17.5 42.5T836 1003H179q-3 0-5.5-2.5T171 994v-77h64q9 0 15-6t6-15-6-15-15-6h-64v-86h64q9 0 15-6t6-15-6-15-15-6h-64v-86h64q9 0 15-6t6-15-6-15-15-6h-64v-86h64q9 0 15-6t6-15-6-15-15-6h-64v-86h64q9 0 15-6t6-15-6-15-15-6h-64v-86h64q9 0 15-6t6-15-6-15-15-6h-64v-81h64q9 0 15-6.5t6-15.5-6-15-15-6h-64V73q0-4 2.5-6.5T179 64zM128 789v86H64q-9 0-15 6t-6 15 6 15 15 6h64v77q0 21 15 36t36 15h657q43 0 73-30t30-72V124q0-43-30-73t-73-30H179q-21 0-36 15t-15 37v38H64q-9 0-15 6t-6 15 6 15.5 15 6.5h64v81H64q-9 0-15 6t-6 15 6 15 15 6h64v86H64q-9 0-15 6t-6 15 6 15 15 6h64v86H64q-9 0-15 6t-6 15 6 15 15 6h64v86H64q-9 0-15 6t-6 15 6 15 15 6h64v86H64q-9 0-15 6t-6 15 6 15 15 6zm265-597q-4 0-6.5 2.5T384 201v238q0 4 2.5 6.5t6.5 2.5h366q4 0 6.5-2.5t2.5-6.5V201q0-4-2.5-6.5T759 192zm-52 9q0-22 15-37t37-15h366q22 0 37 15t15 37v238q0 22-15 37t-37 15H393q-22 0-37-15t-15-37z"
  })
});
const NotebookIcon = ReactComponent$A;
const ReactComponent$z = (props) => /* @__PURE__ */ jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: /* @__PURE__ */ jsx("path", {
    fill: "currentcolor",
    fillRule: "evenodd",
    d: "M13.5 8a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m-.95-.5H4a.5.5 0 0 0 0 1h8.55a2.5 2.5 0 0 0 4.9 0H20a.5.5 0 0 0 0-1h-2.55a2.5 2.5 0 0 0-4.9 0M3.5 16a.5.5 0 0 1 .5-.5h2.55a2.5 2.5 0 0 1 4.9 0H20a.5.5 0 0 1 0 1h-8.55a2.5 2.5 0 0 1-4.9 0H4a.5.5 0 0 1-.5-.5M9 14.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3",
    clipRule: "evenodd"
  })
});
const OptionsIcon = ReactComponent$z;
const ReactComponent$y = (props) => /* @__PURE__ */ jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1024 1024",
  ...props,
  children: /* @__PURE__ */ jsx("path", {
    d: "M939 533q0 36-25 61t-61 25q-35 0-60-25t-25-61q0-35 25-60t60-25q36 0 61 25t25 60m-342 0q0 36-25 61t-60 25-60-25-25-61q0-35 25-60t60-25 60 25 25 60m-341 0q0 36-25 61t-60 25q-36 0-61-25t-25-61q0-35 25-60t61-25q35 0 60 25t25 60"
  })
});
const OverflowHorizontalIcon = ReactComponent$y;
const ReactComponent$x = (props) => /* @__PURE__ */ jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1024 1024",
  ...props,
  children: /* @__PURE__ */ jsx("path", {
    d: "M597 192q0 35-25 60t-60 25-60-25-25-60 25-60 60-25 60 25 25 60m0 341q0 36-25 61t-60 25-60-25-25-61q0-35 25-60t60-25 60 25 25 60m0 342q0 35-25 60t-60 25-60-25-25-60q0-36 25-61t60-25 60 25 25 61"
  })
});
const OverflowVerticalIcon = ReactComponent$x;
const ReactComponent$w = (props) => /* @__PURE__ */ jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20",
  ...props,
  children: [
    /* @__PURE__ */ jsx("rect", {
      width: "15.667",
      height: "15.667",
      x: "2.167",
      y: "2.167",
      stroke: "currentcolor",
      rx: "1.5"
    }),
    /* @__PURE__ */ jsx("path", {
      stroke: "currentcolor",
      d: "M3.667 2.167h4.5v15.666h-4.5a1.5 1.5 0 0 1-1.5-1.5V3.667a1.5 1.5 0 0 1 1.5-1.5Z"
    }),
    /* @__PURE__ */ jsx("path", {
      fill: "currentcolor",
      d: "M18 4a2 2 0 0 0-2-2H8v16h8a2 2 0 0 0 2-2z"
    })
  ]
});
const PanelOnIcon = ReactComponent$w;
const ReactComponent$v = (props) => /* @__PURE__ */ jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20",
  ...props,
  children: [
    /* @__PURE__ */ jsx("rect", {
      width: "15.667",
      height: "15.667",
      x: "2.167",
      y: "2.167",
      stroke: "currentcolor",
      rx: "1.5"
    }),
    /* @__PURE__ */ jsx("path", {
      stroke: "currentcolor",
      d: "M3.667 2.167h4.5v15.666h-4.5a1.5 1.5 0 0 1-1.5-1.5V3.667a1.5 1.5 0 0 1 1.5-1.5Z"
    })
  ]
});
const PanelIcon = ReactComponent$v;
const ReactComponent$u = (props) => /* @__PURE__ */ jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1024 1024",
  ...props,
  children: /* @__PURE__ */ jsx("path", {
    d: "M64 128q9 0 15-6t6-15-6-15.5T64 85t-15 6.5-6 15.5 6 15 15 6m0 107q9 0 15-6.5t6-15.5-6-15-15-6-15 6-6 15 6 15.5 15 6.5m21 85q0 9-6 15t-15 6-15-6-6-15 6-15 15-6 15 6 6 15M64 448q9 0 15-6t6-15-6-15.5-15-6.5-15 6.5-6 15.5 6 15 15 6m21 85q0 9-6 15.5T64 555t-15-6.5-6-15.5 6-15 15-6 15 6 6 15M64 661q9 0 15-6t6-15-6-15-15-6-15 6-6 15 6 15 15 6m21 86q0 9-6 15t-15 6-15-6-6-15 6-15.5 15-6.5 15 6.5 6 15.5M64 875q9 0 15-6.5t6-15.5-6-15-15-6-15 6-6 15 6 15.5 15 6.5m21 85q0 9-6 15t-15 6-15-6-6-15 6-15 15-6 15 6 6 15m278-832q9 0 15-6t6-15-6-15.5-15-6.5-15.5 6.5T341 107t6.5 15 15.5 6m0 107q9 0 15-6.5t6-15.5-6-15-15-6-15.5 6-6.5 15 6.5 15.5T363 235m21 85q0 9-6 15t-15 6-15.5-6-6.5-15 6.5-15 15.5-6 15 6 6 15m-21 128q9 0 15-6t6-15-6-15.5-15-6.5-15.5 6.5T341 427t6.5 15 15.5 6m21 85q0 9-6 15.5t-15 6.5-15.5-6.5T341 533t6.5-15 15.5-6 15 6 6 15m-21 128q9 0 15-6t6-15-6-15-15-6-15.5 6-6.5 15 6.5 15 15.5 6m21 86q0 9-6 15t-15 6-15.5-6-6.5-15 6.5-15.5T363 725t15 6.5 6 15.5m-21 128q9 0 15-6.5t6-15.5-6-15-15-6-15.5 6-6.5 15 6.5 15.5T363 875m21 85q0 9-6 15t-15 6-15.5-6-6.5-15 6.5-15 15.5-6 15 6 6 15m299-853q0 9-6.5 15t-15.5 6-15-6-6-15 6-15.5 15-6.5 15.5 6.5T683 107m0 106q0 9-6.5 15.5T661 235t-15-6.5-6-15.5 6-15 15-6 15.5 6 6.5 15m-22 128q9 0 15.5-6t6.5-15-6.5-15-15.5-6-15 6-6 15 6 15 15 6m22 86q0 9-6.5 15t-15.5 6-15-6-6-15 6-15.5 15-6.5 15.5 6.5T683 427m-22 128q9 0 15.5-6.5T683 533t-6.5-15-15.5-6-15 6-6 15 6 15.5 15 6.5m22 85q0 9-6.5 15t-15.5 6-15-6-6-15 6-15 15-6 15.5 6 6.5 15m-22 128q9 0 15.5-6t6.5-15-6.5-15.5T661 725t-15 6.5-6 15.5 6 15 15 6m22 85q0 9-6.5 15.5T661 875t-15-6.5-6-15.5 6-15 15-6 15.5 6 6.5 15m-22 128q9 0 15.5-6t6.5-15-6.5-15-15.5-6-15 6-6 15 6 15 15 6m299-853q9 0 15-6t6-15-6-15.5-15-6.5-15 6.5-6 15.5 6 15 15 6m0 107q9 0 15-6.5t6-15.5-6-15-15-6-15 6-6 15 6 15.5 15 6.5m21 85q0 9-6 15t-15 6-15-6-6-15 6-15 15-6 15 6 6 15m-21 128q9 0 15-6t6-15-6-15.5-15-6.5-15 6.5-6 15.5 6 15 15 6m21 85q0 9-6 15.5t-15 6.5-15-6.5-6-15.5 6-15 15-6 15 6 6 15m-21 128q9 0 15-6t6-15-6-15-15-6-15 6-6 15 6 15 15 6m21 86q0 9-6 15t-15 6-15-6-6-15 6-15.5 15-6.5 15 6.5 6 15.5m-21 128q9 0 15-6.5t6-15.5-6-15-15-6-15 6-6 15 6 15.5 15 6.5m21 85q0 9-6 15t-15 6-15-6-6-15 6-15 15-6 15 6 6 15M44 206q3-8 11-12t16-1l299 107q2 1 4.5 2.5t3.5 2.5l295 317 40 14 230-328q5-7 13.5-9t15.5 4q7 5 9 13.5t-4 15.5L755 651l212 76q8 3 12 11t1 16-11 12-16 1l-224-80-50 72q-4 6-11 8t-14 0L363 663 71 767q-8 3-16-1t-11-12 1-16 12-11l298-107q4-1 7.5-1t7.5 1l283 101 35-49-34-12q-2-1-4.5-2.5T646 655L351 338 57 233q-8-3-12-11t-1-16"
  })
});
const ParcoordsIcon = ReactComponent$u;
const ReactComponent$t = (props) => /* @__PURE__ */ jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1024 1024",
  ...props,
  children: /* @__PURE__ */ jsx("path", {
    d: "M299 235q-36 0-61 25t-25 60v427q0 35 25 60t61 25h64q35 0 60-25t25-60V320q0-35-25-60t-60-25zm362 0q-35 0-60 25t-25 60v427q0 35 25 60t60 25h64q36 0 61-25t25-60V320q0-35-25-60t-61-25z"
  })
});
const PauseIcon = ReactComponent$t;
const ReactComponent$s = (props) => /* @__PURE__ */ jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1024 1024",
  ...props,
  children: /* @__PURE__ */ jsx("path", {
    d: "M850 107q-25-25-60.5-25T729 107L186 650q-3 3-5 5.5t-4 5.5h-.5l-.5 1h-1l-1 1-1 .5-2 1.5-3 4-124 334 335-123 3-3q2-2 3-3.5t2-3.5q3-2 5.5-4t4.5-4l543-544q25-25 25-60t-25-60zM203 697l2 3q0-1 .5-2t.5-2q3-1 7-1.5t8-1.5q5-1 10-1t10 1q4 0 6 1t2 2l1 1 1 5-.5 9-1.5 12v1q-1 6-1.5 13.5T247 752q1 8 4 17t10 17q8 8 17 11t17 3q8 1 15.5 0t13.5-2q7-1 12.5-1.5t9.5.5q3 0 4.5.5l1.5.5q3 3 4.5 9.5t.5 17.5q0 4-1 8t-2 7q-1 1-3 1.5t-3 .5l2 3-234 86zm195 103q-1-9-5-17t-11-15q-8-8-17-11t-17-3q-7 0-14.5.5T320 756h-1q-7 1-12 1.5t-9 .5q-4-1-5-1.5l-1-.5q-1 0-1.5-1.5t-.5-4.5q0-4 .5-9.5T292 729v-1q0-6 1-13.5t0-15.5q0-8-3-17t-11-17q-7-7-16-10.5t-17-4.5l392-392 151 151zm422-421L669 228l90-91q13-12 30.5-12t30.5 12l90 91q13 12 13 30t-13 30z"
  })
});
const PencilIcon = ReactComponent$s;
const ReactComponent$r = (props) => /* @__PURE__ */ jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  ...props,
  children: /* @__PURE__ */ jsx("path", {
    d: "M9.828.722a.5.5 0 0 1 .354.146l4.95 4.95a.5.5 0 0 1 0 .707c-.48.48-1.072.588-1.503.588-.177 0-.335-.018-.46-.039l-3.134 3.134q.01.042.02.088c.055.234.115.56.14.925.046.702-.032 1.687-.72 2.375a.5.5 0 0 1-.707 0l-2.829-2.828-3.182 3.182c-.195.195-1.219.902-1.414.707s.512-1.22.707-1.414l3.182-3.182-2.828-2.829a.5.5 0 0 1 0-.707c.688-.688 1.673-.767 2.375-.72a6 6 0 0 1 1.013.16l3.134-3.133a3 3 0 0 1-.04-.461c0-.43.108-1.022.589-1.503a.5.5 0 0 1 .353-.146m.122 2.112v-.002zm0-.002v.002a.5.5 0 0 1-.122.51L6.293 6.878a.5.5 0 0 1-.511.12H5.78l-.014-.004-.058-.018a4.922 4.922 0 0 0-.995-.174c-.422-.028-.836.008-1.175.15l5.51 5.509c.141-.34.177-.753.149-1.175a5 5 0 0 0-.192-1.054l-.004-.013v-.001a.5.5 0 0 1 .12-.512l3.536-3.535a.5.5 0 0 1 .532-.115l.096.022c.087.017.208.034.344.034q.172.002.343-.04L9.927 2.028q-.042.172-.04.343a1.8 1.8 0 0 0 .062.46"
  })
});
const PinIcon = ReactComponent$r;
const ReactComponent$q = (props) => /* @__PURE__ */ jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1024 1024",
  ...props,
  children: /* @__PURE__ */ jsx("path", {
    d: "M213 801V266q0-25 21.5-37.5t42.5-.5l469 268q21 13 21 37.5T746 570L277 838q-21 12-42.5 0T213 801"
  })
});
const PlayIcon = ReactComponent$q;
const ReactComponent$p = (props) => /* @__PURE__ */ jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1024 1024",
  ...props,
  children: /* @__PURE__ */ jsx("path", {
    d: "M932 113q2 1 3 3l2 4 1.5 4 .5 4v171q0 9-6.5 15t-15.5 6-15-6-6-15V180L548 527q-6 6-15 6t-15-6-6-15 6-15l348-348H747q-9 0-15.5-6t-6.5-15 6.5-15 15.5-6h171q2 0 4 .5t3 .5l4 2zm-612 79q-34 0-62.5 9T209 230t-29 48.5-9 62.5v384q0 35 9 63t29 48 48.5 29.5T320 875h384q34 0 62.5-9.5T815 836t29-48 9-63V384q0-9-6-15t-15-6-15 6-6 15v341q0 30-7 49.5T785 806t-31.5 19-49.5 7H320q-30 0-49.5-7T239 806t-19-31.5-7-49.5V341q0-29 7-49t19-32 31.5-18.5T320 235h341q9 0 15.5-6.5T683 213t-6.5-15-15.5-6z"
  })
});
const PopoutIcon = ReactComponent$p;
const ReactComponent$o = (props) => /* @__PURE__ */ jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1024 1024",
  ...props,
  children: /* @__PURE__ */ jsx("path", {
    d: "M512 107q9 0 15 6t6 15v299q0 9-6 15t-15 6-15-6-6-15V128q0-9 6-15t15-6m341 426q0 71-26 133-27 62-73.5 108.5T645 848t-133 27-133-27-108.5-73.5T197 666q-26-62-26-133 0-52 15-100 14-47 41-87.5t64-72.5q38-32 82-52l-17-39q-50 23-92 58-42 36-72.5 81.5T145 421q-17 54-17 112 0 80 30 150t82.5 122T363 887q69 30 149 30t149-30q70-30 122.5-82T866 683t30-150q0-58-17-112-16-54-46.5-99.5T760 240q-42-35-92-58l-17 39q44 20 82 52 37 32 64 72.5t41 87.5q15 48 15 100M384 203q0 8-6 14.5t-15 6.5-15-6.5-6-14.5q0-9 6-15.5t15-6.5 15 6.5 6 15.5m298 0q0 8-6 14.5t-15 6.5-15-6.5-6-14.5q0-9 6-15.5t15-6.5 15 6.5 6 15.5"
  })
});
const PowerIcon = ReactComponent$o;
const ReactComponent$n = (props) => /* @__PURE__ */ jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1024 1024",
  ...props,
  children: /* @__PURE__ */ jsx("path", {
    d: "M277 64q9 0 15.5 6t6.5 15v768q0 9-6.5 15.5T277 875t-15-6.5-6-15.5V85q0-9 6-15t15-6m235 0q9 0 15 6t6 15v768q0 9-6 15.5t-15 6.5-15-6.5-6-15.5V85q0-9 6-15t15-6m235 0q9 0 15 6t6 15v768q0 9-6 15.5t-15 6.5-15.5-6.5T725 853V85q0-9 6.5-15t15.5-6M64 832q9 0 15 6t6 15v107h854V853q0-9 6-15t15-6 15 6 6 15v128q0 9-6 15.5t-15 6.5H64q-9 0-15-6.5T43 981V853q0-9 6-15t15-6M6 369q6-6 15-6t15 6l86 85q6 6 6 15t-6 15l-86 86q-6 6-15 6t-15-6-6-15 6-15l70-71-70-70q-6-6-6-15t6-15m896 0q6-6 15-6t15 6l86 85q6 6 6 15t-6 15l-86 86q-6 6-15 6t-15-6-6-15 6-15l70-71-70-70q-6-6-6-15t6-15"
  })
});
const QueueIcon = ReactComponent$n;
const ReactComponent$m = (props) => /* @__PURE__ */ jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1024 1024",
  ...props,
  children: /* @__PURE__ */ jsx("path", {
    d: "M171 533q0-70 26-133 27-62 73.5-108T379 219t133-27v43q-62 0-116 23-55 24-95.5 64.5T237 417q-24 54-24 116t24 117q23 54 63.5 94.5T396 809q54 23 116 23t116-23q55-24 95.5-64.5T787 650q24-55 24-117 0-69-29-128t-78-100v122q0 9-6 15t-15 6-15.5-6-6.5-15V256q0-9 6.5-15t15.5-6h170q9 0 15.5 6t6.5 15-6.5 15-15.5 6H738q53 47 84 113.5T853 533q0 71-26 133-27 62-73.5 108.5T645 848t-133 27-133-27-108.5-73.5T197 666q-26-62-26-133"
  })
});
const ResetIcon = ReactComponent$m;
const ReactComponent$l = (props) => /* @__PURE__ */ jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: /* @__PURE__ */ jsx("rect", {
    width: "15",
    height: "13",
    x: "4.5",
    y: "5.5",
    stroke: "currentcolor",
    rx: ".5"
  })
});
const RowExtraLargeIcon = ReactComponent$l;
const ReactComponent$k = (props) => /* @__PURE__ */ jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: /* @__PURE__ */ jsx("path", {
    fill: "currentcolor",
    fillRule: "evenodd",
    d: "M5 6h14v8H5zM4 6a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1zm.5 12a.5.5 0 0 0 0 1h15a.5.5 0 0 0 0-1z",
    clipRule: "evenodd"
  })
});
const RowLargeIcon = ReactComponent$k;
const ReactComponent$j = (props) => /* @__PURE__ */ jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: /* @__PURE__ */ jsx("path", {
    fill: "currentcolor",
    fillRule: "evenodd",
    d: "M19 6H5v4h14zM5 5a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1zm-1 9.5a.5.5 0 0 1 .5-.5h15a.5.5 0 0 1 0 1h-15a.5.5 0 0 1-.5-.5m.5 3.5a.5.5 0 0 0 0 1h15a.5.5 0 0 0 0-1z",
    clipRule: "evenodd"
  })
});
const RowMediumIcon = ReactComponent$j;
const ReactComponent$i = (props) => /* @__PURE__ */ jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: /* @__PURE__ */ jsx("path", {
    fill: "currentcolor",
    fillRule: "evenodd",
    d: "M4.5 6a.5.5 0 0 0 0 1h15a.5.5 0 0 0 0-1zm0 4a.5.5 0 0 0 0 1h15a.5.5 0 0 0 0-1zM4 14.5a.5.5 0 0 1 .5-.5h15a.5.5 0 0 1 0 1h-15a.5.5 0 0 1-.5-.5m.5 3.5a.5.5 0 0 0 0 1h15a.5.5 0 0 0 0-1z",
    clipRule: "evenodd"
  })
});
const RowSmallIcon = ReactComponent$i;
const ReactComponent$h = (props) => /* @__PURE__ */ jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1024 1024",
  ...props,
  children: /* @__PURE__ */ jsx("path", {
    d: "M774 156q6-7 15-7t15 7l28 27 28-27q6-7 15-7t15 7q6 6 6 15t-6 15l-28 27 28 28q6 6 6 15t-6 15-15 6-15-6l-28-27-28 27q-6 6-15 6t-15-6-6-15 6-15l28-28-28-27q-6-6-6-15t6-15M348 369q6-6 15-6t15 6l27 27 28-27q6-6 15-6t15 6 6 15-6 15l-27 28 27 27q6 6 6 15t-6 15q-6 7-15 7t-15-7l-28-27-27 27q-6 7-15 7t-15-7q-7-6-7-15t7-15l27-27-27-28q-7-6-7-15t7-15M134 582q6-6 15-6t15 6l28 28 28-28q6-6 15-6t15 6 6 15-6 15l-28 28 28 28q6 6 6 15t-6 15-15 6-15-6l-28-28-28 28q-6 6-15 6t-15-6-6-15 6-15l28-28-28-28q-6-6-6-15t6-15m30 214q-6-7-15-7t-15 7q-6 6-6 15t6 15l28 27-28 28q-6 6-6 15t6 15 15 6 15-6l28-27 28 27q6 6 15 6t15-6 6-15-6-15l-28-28 28-27q6-6 6-15t-6-15q-6-7-15-7t-15 7l-28 27zm184-214q6-6 15-6t15 6l27 28 28-28q6-6 15-6t15 6 6 15-6 15l-27 28 27 28q6 6 6 15t-6 15-15 6-15-6l-28-28-27 28q-6 6-15 6t-15-6q-7-6-7-15t7-15l27-28-27-28q-7-6-7-15t7-15m213 214q6-7 15-7t15 7l28 27 27-27q6-7 15-7t15 7q7 6 7 15t-7 15l-27 27 27 28q7 6 7 15t-7 15q-6 6-15 6t-15-6l-27-27-28 27q-6 6-15 6t-15-6-6-15 6-15l27-28-27-27q-6-6-6-15t6-15m0-427q6-6 15-6t15 6l28 27 27-27q6-6 15-6t15 6q7 6 7 15t-7 15l-27 28 27 27q7 6 7 15t-7 15q-6 7-15 7t-15-7l-27-27-28 27q-6 7-15 7t-15-7q-6-6-6-15t6-15l27-27-27-28q-6-6-6-15t6-15m213 0q6-6 15-6t15 6l28 27 28-27q6-6 15-6t15 6 6 15-6 15l-28 28 28 27q6 6 6 15t-6 15q-6 7-15 7t-15-7l-28-27-28 27q-6 7-15 7t-15-7q-6-6-6-15t6-15l28-27-28-28q-6-6-6-15t6-15m0 213q6-6 15-6t15 6l28 28 28-28q6-6 15-6t15 6 6 15-6 15l-28 28 28 28q6 6 6 15t-6 15-15 6-15-6l-28-28-28 28q-6 6-15 6t-15-6-6-15 6-15l28-28-28-28q-6-6-6-15t6-15"
  })
});
const ScatterPlotIcon = ReactComponent$h;
const ReactComponent$g = (props) => /* @__PURE__ */ jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  ...props,
  children: /* @__PURE__ */ jsxs("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    children: [
      /* @__PURE__ */ jsx("path", {
        d: "M4.5 5.5h8.2"
      }),
      /* @__PURE__ */ jsx("path", {
        strokeOpacity: "0.72",
        d: "M4.5 9.5h8.2"
      }),
      /* @__PURE__ */ jsx("path", {
        strokeOpacity: "0.48",
        d: "M4.5 13.5h8.2"
      }),
      /* @__PURE__ */ jsx("path", {
        strokeOpacity: "0.24",
        d: "M4.5 17.5h8.2"
      }),
      /* @__PURE__ */ jsx("path", {
        d: "M20 15.706 17.6 18m0 0-2.4-2.294M17.6 18V5"
      })
    ]
  })
});
const ScrollIcon = ReactComponent$g;
const ReactComponent$f = (props) => /* @__PURE__ */ jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1024 1024",
  ...props,
  children: /* @__PURE__ */ jsx("path", {
    d: "M768 448q0-71-27-133t-73-108.5T560 133q-63-26-133-26-71 0-133 26-62 27-108.5 73.5T112 315 85 448t27 133 73.5 108.5T294 763q62 26 133 26 70 0 133-26 62-27 108-73.5T741 581t27-133m-71 330q-55 46-124 71.5T427 875q-89 0-166-34-78-33-136-91T34 614Q0 536 0 448t34-166q33-78 91-136t136-91q77-34 166-34 88 0 166 34 77 33 135 91t92 136q33 78 33 166 0 77-25.5 146T757 718l255 254q12 13 12 30.5t-12 30.5q-13 12-30.5 12t-30.5-12z"
  })
});
const SearchIcon = ReactComponent$f;
const ReactComponent$e = (props) => /* @__PURE__ */ jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1075 1024",
  ...props,
  children: /* @__PURE__ */ jsx("path", {
    d: "M690 124H229zM535 533H36zm437 410H434zM229 73v102h461V73zM113 277v103h315V277zM36 482v103h499V482zm308 205v102h448V687zm90 205v102h538V892z"
  })
});
const SearcherAdaptiveIcon = ReactComponent$e;
const ReactComponent$d = (props) => /* @__PURE__ */ jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1075 1024",
  ...props,
  children: /* @__PURE__ */ jsx("path", {
    d: "M137 192q0 18 12.5 30.5T179 235q18 0 30.5-12.5T222 192t-12.5-30.5T179 149q-17 0-29.5 12.5T137 192m42-94q-38 0-66 28t-28 66 28 66 66 28q39 0 66.5-28t27.5-66-27.5-66T179 98m0 85q3 0 6 3t3 6-3 6-6 3-5.5-3-2.5-6 2.5-6 5.5-3m299 9q0 18 12.5 30.5T521 235q17 0 29.5-12.5T563 192t-12.5-30.5T521 149q-18 0-30.5 12.5T478 192m42-94q-38 0-65.5 28T427 192t27.5 66 65.5 28q39 0 66.5-28t27.5-66-27.5-66T520 98m1 85q3 0 5.5 3t2.5 6-2.5 6-5.5 3q-4 0-6.5-3t-2.5-6 2.5-6 6.5-3m298 9q0 18 12.5 30.5T862 235t30.5-12.5T905 192t-12.5-30.5T862 149t-30.5 12.5T819 192m43-94q-39 0-66.5 28T768 192t27.5 66 66.5 28q38 0 66-28t28-66-28-66-66-28m0 85q3 0 5.5 3t2.5 6-2.5 6-5.5 3-6-3-3-6 3-6 6-3M137 533q0 18 12.5 30.5T179 576q18 0 30.5-12.5T222 533q0-17-12.5-29.5T179 491q-17 0-29.5 12.5T137 533m42-94q-38 0-66 28t-28 66q0 39 28 66.5t66 27.5q39 0 66.5-27.5T273 533q0-38-27.5-66T179 439m0 86q3 0 6 2.5t3 5.5-3 6-6 3-5.5-3-2.5-6 2.5-5.5 5.5-2.5m299 8q0 18 12.5 30.5T521 576q17 0 29.5-12.5T563 533q0-17-12.5-29.5T521 491q-18 0-30.5 12.5T478 533m42-94q-38 0-65.5 28T427 533q0 39 27.5 66.5T520 627q39 0 66.5-27.5T614 533q0-38-27.5-66T520 439m1 86q3 0 5.5 2.5t2.5 5.5-2.5 6-5.5 3q-4 0-6.5-3t-2.5-6 2.5-5.5 6.5-2.5m298 8q0 18 12.5 30.5T862 576t30.5-12.5T905 533q0-17-12.5-29.5T862 491t-30.5 12.5T819 533m43-94q-39 0-66.5 28T768 533q0 39 27.5 66.5T862 627q38 0 66-27.5t28-66.5q0-38-28-66t-66-28m0 86q3 0 5.5 2.5t2.5 5.5-2.5 6-5.5 3-6-3-3-6 3-5.5 6-2.5M137 875q0 17 12.5 29.5T179 917q18 0 30.5-12.5T222 875q0-18-12.5-30.5T179 832q-17 0-29.5 12.5T137 875m42-94q-38 0-66 27.5T85 875q0 38 28 66t66 28q39 0 66.5-28t27.5-66q0-39-27.5-66.5T179 781m0 85q3 0 6 3t3 6-3 5.5-6 2.5-5.5-2.5-2.5-5.5 2.5-6 5.5-3m299 9q0 17 12.5 29.5T521 917q17 0 29.5-12.5T563 875q0-18-12.5-30.5T521 832q-18 0-30.5 12.5T478 875m42-94q-38 0-65.5 27.5T427 875q0 38 27.5 66t65.5 28q39 0 66.5-28t27.5-66q0-39-27.5-66.5T520 781m1 85q3 0 5.5 3t2.5 6-2.5 5.5-5.5 2.5q-4 0-6.5-2.5T512 875t2.5-6 6.5-3m298 9q0 17 12.5 29.5T862 917t30.5-12.5T905 875q0-18-12.5-30.5T862 832t-30.5 12.5T819 875m43-94q-39 0-66.5 27.5T768 875q0 38 27.5 66t66.5 28q38 0 66-28t28-66q0-39-28-66.5T862 781m0 85q3 0 5.5 3t2.5 6-2.5 5.5-5.5 2.5-6-2.5-3-5.5 3-6 6-3"
  })
});
const SearcherGridIcon = ReactComponent$d;
const ReactComponent$c = (props) => /* @__PURE__ */ jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1075 1024",
  ...props,
  children: /* @__PURE__ */ jsx("path", {
    d: "M285 513v4l-1 4-2 3.5-3 2.5q-1 2-2.5 3t-3.5 2-4 1H138l-4-1-3.5-2-2.5-3q-2-1-3-2.5t-2-3.5-1-4V386l1-4 2-3.5 3-3.5q1-1 2.5-2t3.5-2 4-1.5 4-.5h123q2 0 4 .5t4 1.5 3.5 2 2.5 2q2 2 3 3.5t2 3.5 1 4zm164 409q0 2-.5 4t-.5 4l-2 4-3 3q-1 1-3 2.5t-3 1.5q-2 1-4 1.5t-4 .5H306q-2 0-4-.5t-4-1.5q-2 0-3.5-1.5T291 937q-1-1-2-3l-2-4-1.5-4-.5-4V800q0-2 .5-4t1.5-4 2-3.5 2-3.5q2-1 3.5-2.5t3.5-1.5q2-1 4-1.5t4-.5h123q2 0 4 .5t4 1.5q1 0 3 1.5t3 2.5q2 2 3 3.5t2 3.5q0 2 .5 4t.5 4zm492-327q0 2-.5 4t-1.5 4q-1 1-2 3t-2 3q-2 2-3.5 3t-3.5 2q-2 0-4 .5t-4 .5H797q-2 0-4-.5t-3-.5l-4-2-3-3q-1-1-2.5-3t-1.5-3q-1-2-1.5-4t-.5-4V472q0-2 .5-4t1.5-4q0-2 1.5-3.5t2.5-3.5q1-1 3-2l4-2q1-1 3-1.5t4-.5h123q2 0 4 .5t4 1.5 3.5 2 3.5 2q1 2 2 3.5t2 3.5 1.5 4 .5 4zm-492 82q0 2 .5 4t1.5 4q1 1 2 3t2 3q2 2 3.5 3t3.5 2q2 0 4 .5t4 .5h123q2 0 4-.5t3-.5l4-2 3-3q2-1 3-3t2-3q0-2 .5-4t.5-4V554q0-2-.5-4t-.5-4q-1-2-2-3.5t-3-3.5q-1-1-3-2l-4-2q-1-1-3-1.5t-4-.5H470q-2 0-4 .5t-4 1.5-3.5 2-3.5 2q-1 2-2 3.5t-2 3.5-1.5 4-.5 4zm164-410q0 2 .5 4t1.5 4q0 2 1.5 3.5t2.5 3.5q2 1 3.5 2t3.5 2 4 1.5 4 .5h122q2 0 4-.5t4-1.5l4-2 3-2q1-2 2.5-3.5t1.5-3.5q1-2 1.5-4t.5-4V144q0-2-.5-4t-1.5-4q0-1-1.5-3t-2.5-3q-1-2-3-3l-4-2q-2 0-4-.5t-4-.5H634q-2 0-4 .5t-4 .5q-2 1-3.5 2t-3.5 3q-1 1-2.5 3t-1.5 3q-1 2-1.5 4t-.5 4z"
  })
});
const SearcherRandomIcon = ReactComponent$c;
const ReactComponent$b = (props) => /* @__PURE__ */ jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1024 1024",
  ...props,
  children: /* @__PURE__ */ jsx("path", {
    d: "M683 320q-18 0-30.5-12.5T640 277q0-17 12.5-29.5T683 235q17 0 29.5 12.5T725 277q0 18-12.5 30.5T683 320m0 43q35 0 60-25t25-61q0-35-25-60t-60-25q-36 0-61 25t-25 60q0 36 25 61t61 25M299 576q-18 0-30.5-12.5T256 533q0-17 12.5-29.5T299 491q17 0 29.5 12.5T341 533q0 18-12.5 30.5T299 576m0 43q35 0 60-25t25-61q0-35-25-60t-60-25q-36 0-61 25t-25 60q0 36 25 61t61 25m213 213q-18 0-30.5-12.5T469 789q0-17 12.5-29.5T512 747t30.5 12.5T555 789q0 18-12.5 30.5T512 832m0 43q35 0 60-25t25-61q0-35-25-60t-60-25-60 25-25 60q0 36 25 61t60 25m253-576q2-5 2.5-10.5t.5-11.5q0-5-.5-10.5T765 256h67q9 0 15 6t6 15-6 15.5-15 6.5zm-165 0H192q-9 0-15-6.5t-6-15.5 6-15 15-6h408q-1 5-2 10.5t-1 10.5q0 6 1 11.5t2 10.5M381 555q2-5 2.5-10.5t.5-11.5q0-5-.5-10.5T381 512h451q9 0 15 6t6 15-6 15.5-15 6.5zm-165 0h-24q-9 0-15-6.5t-6-15.5 6-15 15-6h24q-1 5-2 10.5t-1 10.5q0 6 1 11.5t2 10.5m379 256h237q9 0 15-6.5t6-15.5-6-15-15-6H595q1 5 1.5 10.5t.5 10.5q0 6-.5 11.5T595 811m-166 0q-1-5-1.5-10.5T427 789q0-5 .5-10.5T429 768H192q-9 0-15 6t-6 15 6 15.5 15 6.5z"
  })
});
const SettingsIcon = ReactComponent$b;
const ReactComponent$a = (props) => /* @__PURE__ */ jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1024 1024",
  ...props,
  children: /* @__PURE__ */ jsx("path", {
    d: "M973 107q3 0 5.5 2.5t2.5 5.5v836q0 4-2.5 6.5T973 960H51q-3 0-5.5-2.5T43 951V115q0-3 2.5-5.5T51 107zM51 64q-21 0-36 15T0 115v836q0 22 15 37t36 15h922q21 0 36-15t15-37V115q0-21-15-36t-36-15zm-8 128h938v43H43zm384 171h42v147q12-9 28-14t36-5q34 0 55.5 13t33.5 33q11 18 14.5 37t3.5 32v226h-43V606q0-10-2.5-23t-9.5-24q-6-10-18-18t-34-8-33.5 8-18.5 18q-7 11-9.5 24t-2.5 23v226h-42zm305 134q6-6 15-6t15 6l149 151q6 7 6 15.5t-6 15.5L762 828q-6 6-15 6t-15-6q-7-6-7-15t7-15l134-135-135-136q-6-6-6-15t7-15m-576 22q15-14 35-21t44-7q51 0 78.5 32t27.5 66h-42q0-18-16-37t-48-19q-18 0-30 5t-19 12-11 17-4 22q0 11 4.5 18.5T188 620q9 7 22.5 11.5T241 641h1q16 5 32.5 11t30.5 15q16 11 26 27t10 40q0 21-7 39.5T313 806q-15 13-35 19.5t-43 6.5q-51 0-79-32t-28-66h43q0 17 15.5 36t48.5 19q18 0 30-4t19-11q7-6 11-16t4-24q0-12-4.5-19T281 703q-9-7-22.5-11.5T229 682q-1 0-1.5-.5l-.5-.5q-15-4-32-10t-31-15q-16-11-26-27t-10-40q0-20 7-38t21-32"
  })
});
const ShellIcon = ReactComponent$a;
const ReactComponent$9 = (props) => /* @__PURE__ */ jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1024 1024",
  ...props,
  children: /* @__PURE__ */ jsx("path", {
    d: "M150 171q35-34 76-62t87-47.5T409 32q50-11 103-11t103 11q50 10 96 29.5t87 47.5 76 62l-60 61q-29-29-63-52-35-24-73-40t-80-25q-42-8-86-8t-86 8q-42 9-80 25t-73 40q-34 23-63 52z"
  })
});
const SpinnerIcon = ReactComponent$9;
const ReactComponent$8 = (props) => /* @__PURE__ */ jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1024 1024",
  ...props,
  children: /* @__PURE__ */ jsx("path", {
    d: "M626 326q12 28 36 45.5t54 19.5l246 20q14 1 18.5 14.5T974 448L786 609q-22 19-31.5 47.5T752 714l57 240q4 14-7.5 22t-23.5 1L567 848q-25-15-55-15t-55 15L246 977q-12 7-23.5-1t-7.5-22l57-240q7-29-2.5-57.5T238 609L50 448q-11-9-6.5-22.5T62 411l246-20q30-2 54-19.5t36-45.5l95-228q5-13 19-13t19 13zM571 82q-16-39-59-39t-59 39l-95 228q-6 16-20.5 26.5T305 349L59 369q-43 3-56 43.5T22 480l188 161q13 12 18.5 29t1.5 34l-57 240q-10 41 24.5 66t70.5 3l211-128q15-10 33-10t33 10l211 128q36 22 70.5-3t24.5-66l-57-240q-4-17 1.5-34t18.5-29l188-161q32-27 19-67.5T965 369l-246-20q-18-2-32.5-12.5T666 310z"
  })
});
const StarIcon = ReactComponent$8;
const ReactComponent$7 = (props) => /* @__PURE__ */ jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1024 1024",
  ...props,
  children: /* @__PURE__ */ jsx("path", {
    d: "M299 235h426q36 0 61 25t25 60v427q0 35-25 60t-61 25H299q-36 0-61-25t-25-60V320q0-35 25-60t61-25"
  })
});
const StopIcon = ReactComponent$7;
const ReactComponent$6 = (props) => /* @__PURE__ */ jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1024 1024",
  ...props,
  children: /* @__PURE__ */ jsx("path", {
    d: "M717 64q3 0 5.5 2.5T725 73v34H222q-21 0-36 15t-15 36v674h-34q-4 0-6.5-2.5T128 823V73q0-4 2.5-6.5T137 64zm51 43V73q0-22-15-37t-36-15H137q-22 0-37 15T85 73v750q0 22 15 37t37 15h34v34q0 21 15 36t36 15h34v34q0 21 15 36t36 15h397l235-234V243q0-21-15-36t-37-15h-34v-34q0-21-15-36t-36-15zm-546 42h580q4 0 6.5 2.5t2.5 6.5v34H307q-21 0-36 15t-15 36v674h-34q-4 0-6.5-2.5T213 909V158q0-4 2.5-6.5t6.5-2.5m85 86h580q4 0 6.5 2.5t2.5 5.5v546H704q-9 0-15 6.5t-6 15.5v192H307q-3 0-5.5-2.5T299 994V243q0-3 2.5-5.5t5.5-2.5m418 597h141L725 972zm15-305L570 698q-6 6-15 6t-15-6l-86-86q-6-6-6-15t6-15 15-6 15 6l71 70 155-155q6-6 15-6t15 6q7 6 7 15t-7 15"
  })
});
const TasksIcon = ReactComponent$6;
const ReactComponent$5 = (props) => /* @__PURE__ */ jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1024 1024",
  ...props,
  children: /* @__PURE__ */ jsx("path", {
    d: "M969 271 531 21v1024l176-101V656l132 76-2-197-130-76V344l262 154zm-915 0L492 21v1024L317 944V344L54 498z"
  })
});
const TensorBoardIcon = ReactComponent$5;
const ReactComponent$4 = (props) => /* @__PURE__ */ jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1024 1024",
  ...props,
  children: /* @__PURE__ */ jsx("path", {
    d: "M512 21q-9 0-15 6.5T491 43v64H51q-21 0-36 15T0 158v708q0 21 15 36t36 15h218l-33 100q-3 9 1 16.5t12 10.5q9 3 16.5-1t10.5-12l38-114h396l38 114q3 8 10.5 12t16.5 1q8-3 12-10.5t1-16.5l-33-100h218q21 0 36-15t15-36V158q0-21-15-36t-36-15H533V43q0-9-6-15.5T512 21M51 149h922q3 0 5.5 2.5t2.5 6.5v708q0 4-2.5 6.5T973 875H51q-3 0-5.5-2.5T43 866V158q0-4 2.5-6.5T51 149m116 95 174 265 178-30 185 167 177 59q9 3 13 11t1 16-11 12-16 2l-186-62-177-159-185 31-189-288q-4-8-2.5-16.5T138 238q7-5 15.5-3t13.5 9"
  })
});
const TensorboardIcon = ReactComponent$4;
const ReactComponent$3 = (props) => /* @__PURE__ */ jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1024 1024",
  ...props,
  children: /* @__PURE__ */ jsx("path", {
    d: "M335 198q6 6 6 15t-6 15l-91 92h396q52 0 99 20 47 21 81.5 55.5T876 477q20 47 20 99t-20 99q-21 47-55.5 81.5T739 812q-47 20-99 20H149q-9 0-15-6t-6-15 6-15.5 15-6.5h491q44 0 82-17 39-17 68-46t46-68q17-38 17-82t-17-82q-17-39-46-68t-68-46q-38-17-82-17H244l91 91q6 6 6 15t-6 15q-6 7-15 7t-15-7L177 356q-6-6-6-15t6-15l128-128q6-6 15-6t15 6"
  })
});
const UndoIcon = ReactComponent$3;
const ReactComponent$2 = (props) => /* @__PURE__ */ jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1024 1024",
  ...props,
  children: /* @__PURE__ */ jsx("path", {
    d: "M683 363q0 70-50 120t-121 50-121-50-50-120q0-71 50-121t121-50 121 50 50 121m-65 185q48-28 77.5-77T725 363q0-45-16-83-17-39-46-68t-68-46-83-17-83 17-68 46-46 68q-16 38-16 83 0 59 29.5 108t77.5 77q-60 17-111 52-51 36-88 84.5T149 792q-21 60-21 125h43q0-70 26-133 27-62 73.5-108T379 603t133-27 133 27 108.5 73T827 784q26 63 26 133h43q0-65-21-125-21-59-58-107.5T729 600q-51-35-111-52"
  })
});
const UserIcon = ReactComponent$2;
const ReactComponent$1 = (props) => /* @__PURE__ */ jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1024 1024",
  ...props,
  children: /* @__PURE__ */ jsx("path", {
    d: "M567 224q-19-31-55-31t-55 31L119 777q-20 32-1.5 65t56.5 33h676q38 0 56.5-33t-1.5-65zm-146-22q31-51 91-51t91 51l338 553q33 53 2.5 107.5T850 917H174q-63 0-93.5-54.5T83 755zm112 566q0 9-6 15t-15 6-15-6-6-15 6-15 15-6 15 6 6 15m-21-384q-9 0-15 6t-6 15v256q0 9 6 15.5t15 6.5 15-6.5 6-15.5V405q0-9-6-15t-15-6"
  })
});
const WarningIcon = ReactComponent$1;
const ReactComponent = (props) => /* @__PURE__ */ jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1024 1024",
  ...props,
  children: /* @__PURE__ */ jsx("path", {
    d: "M868 64H369q-47 0-80 33t-33 80v143h45V177q0-28 20-48t48-20h499q28 0 48 20t20 48v499q0 28-20 48t-48 20H725v45h143q47 0 80-33t33-80V177q0-47-33-80t-80-33M149 277h512q45 0 76 31.5t31 75.5v512q0 44-31 75.5t-76 31.5H149q-44 0-75-31.5T43 896V384q0-44 31-75.5t75-31.5m0 43q-26 0-45 18.5T85 384v512q0 27 19 45.5t45 18.5h512q27 0 45.5-18.5T725 896V384q0-27-18.5-45.5T661 320z"
  })
});
const WorkspacesIcon = ReactComponent;
const IconSizeArray = [
  "tiny",
  "small",
  "medium",
  "large",
  "big",
  "great",
  "huge",
  "enormous",
  "giant",
  "jumbo",
  "mega"
];
const svgIconMap = {
  "add": AddIcon,
  "archive": ArchiveIcon,
  "arrow-down": ArrowDownIcon,
  "arrow-left": ArrowLeftIcon,
  "arrow-right": ArrowRightIcon,
  "arrow-up": ArrowUpIcon,
  "cancelled": CancelledIcon,
  "checkmark": CheckmarkIcon,
  "checkpoint": CheckpointIcon,
  "clipboard": ClipboardIcon,
  "close": CloseIcon,
  "cloud": CloudIcon,
  "cluster": ClusterIcon,
  "collapse": CollapseIcon,
  "columns": ColumnsIcon,
  "command": CommandIcon,
  "critical": ErrorIcon,
  // duplicate of error
  "dai-logo": DaiLogoIcon,
  "dashboard": DashboardIcon,
  "debug": DebugIcon,
  "docs": DocsIcon,
  "document": DocumentIcon,
  "download": DownloadIcon,
  "error": ErrorIcon,
  "expand": ExpandIcon,
  "experiment": ExperimentIcon,
  "external": GroupIcon,
  // duplicate of group
  "eye-close": EyeCloseIcon,
  "eye-open": EyeOpenIcon,
  "filter": FilterIcon,
  "fork": ForkIcon,
  "four-squares": FourSquaresIcon,
  "fullscreen": FullscreenIcon,
  "grid": GridIcon,
  "group": GroupIcon,
  "heat": HeatIcon,
  "heatmap": HeatmapIcon,
  "home": HomeIcon,
  "info": InfoIcon,
  "jupyter-lab": JupyterLabIcon,
  "learning": LearningIcon,
  "list": ListIcon,
  "lock": LockIcon,
  "logs": LogsIcon,
  "model": ModelIcon,
  "notebook": NotebookIcon,
  "options": OptionsIcon,
  "overflow-horizontal": OverflowHorizontalIcon,
  "overflow-vertical": OverflowVerticalIcon,
  "panel": PanelIcon,
  "panel-on": PanelOnIcon,
  "parcoords": ParcoordsIcon,
  "pause": PauseIcon,
  "pencil": PencilIcon,
  "pin": PinIcon,
  "play": PlayIcon,
  "popout": PopoutIcon,
  "power": PowerIcon,
  "queue": QueueIcon,
  "reset": ResetIcon,
  "row-large": RowLargeIcon,
  "row-medium": RowMediumIcon,
  "row-small": RowSmallIcon,
  "row-xl": RowExtraLargeIcon,
  "scatter-plot": ScatterPlotIcon,
  "scroll": ScrollIcon,
  "search": SearchIcon,
  "searcher-adaptive": SearcherAdaptiveIcon,
  "searcher-grid": SearcherGridIcon,
  "searcher-random": SearcherRandomIcon,
  "settings": SettingsIcon,
  "shell": ShellIcon,
  "spinner": SpinnerIcon,
  "star": StarIcon,
  "stop": StopIcon,
  "tasks": TasksIcon,
  "tensor-board": TensorBoardIcon,
  "tensorboard": TensorboardIcon,
  "trace": DaiLogoIcon,
  // duplicate of dai-logo
  "undo": UndoIcon,
  "user": UserIcon,
  "warning": WarningIcon,
  "webhooks": SearcherRandomIcon,
  // duplicate of searcher-random
  "workspaces": WorkspacesIcon
};
const antdIconMap = {
  "exclamation-circle": ExclamationCircleOutlined,
  "holder": HolderOutlined,
  "minus-circle": MinusCircleOutlined,
  "project": ProjectOutlined
};
const componentIconMap = {
  "active": Active,
  "queued": Queue,
  "spin-bowtie": SpinBowtie,
  "spin-half": SpinHalf,
  "spin-shadow": SpinShadow
};
const iconMap = {
  ...svgIconMap,
  ...antdIconMap,
  ...componentIconMap
};
const IconNameArray = Object.keys(iconMap);
const Icon = ({
  name,
  size = "medium",
  color,
  decorative,
  title,
  showTooltip = false,
  backgroundColor,
  opacity
}) => {
  const {
    themeSettings: { className: themeClass }
  } = useTheme();
  const classes = [css.base, themeClass];
  const iconComponent = useMemo(() => {
    if (name === "queued")
      return /* @__PURE__ */ jsx(Queue, { backgroundColor, opacity });
    const MappedIcon = iconMap[name];
    return /* @__PURE__ */ jsx(MappedIcon, {});
  }, [backgroundColor, name, opacity]);
  if (size)
    classes.push(css[size]);
  if (color)
    classes.push(css[color]);
  if (name === "spinner")
    classes.push(css.spin);
  const icon = (
    // antdicons have aria-labels already
    /* @__PURE__ */ jsx("span", { "aria-label": name in antdIconMap ? void 0 : title, className: classes.join(" "), children: iconComponent })
  );
  return showTooltip && !decorative ? /* @__PURE__ */ jsx(Tooltip, { content: title, children: icon }) : icon;
};
export {
  IconNameArray,
  IconSizeArray,
  antdIconMap,
  componentIconMap,
  Icon as default,
  svgIconMap
};
